/** Generated by scripts/generate-release-info.mjs — do not edit by hand. */

export type ReleaseNote = {
  version: string;
  releasedAt: string;
  summary: string;
};

export const RELEASE_VERSION = "3.15.3";
export const RELEASED_AT = "2026-10-14T21:53:35.178Z";

export const RELEASE_NOTES: ReleaseNote[] = [
  {
    "version": "3.15.3",
    "releasedAt": "2026-10-14T21:53:35.178Z",
    "summary": "- Astro tab shows a small moon/star icon beside the label in the web and mobile tab strips."
  },
  {
    "version": "3.15.2",
    "releasedAt": "2026-10-14T21:51:56.243Z",
    "summary": "- Rename the Astrology tab to Astro on web, mobile, and Mac terminal."
  },
  {
    "version": "3.15.1",
    "releasedAt": "2026-10-14T21:37:07.631Z",
    "summary": "- Mobile: restore the Options tab after Focus+ removal (it could stay hidden if Options was previously turned off in tab settings)."
  },
  {
    "version": "3.15.0",
    "releasedAt": "2026-10-14T16:37:23.971Z",
    "summary": "- Removed Focus, History-SF, Calls+, and Analytics-SF from web, mobile, and Mac terminal — they no longer appear in the tab bar or tab settings.\n- Saved last-used / default tab preferences for those tabs migrate to Options, History, Calls, or Analytics automatically."
  },
  {
    "version": "3.14.3",
    "releasedAt": "2026-10-10T02:58:45.464Z",
    "summary": "- Astrology posture chart overlays S&P 500 (SPY) YTD % on a right axis next to the timing score"
  },
  {
    "version": "3.14.2",
    "releasedAt": "2026-10-10T02:45:51.211Z",
    "summary": "- Astrology posture chart: solid observed YTD + dashed prediction for the rest of the year, with forecast hot-window callouts"
  },
  {
    "version": "3.14.1",
    "releasedAt": "2026-10-10T02:42:24.705Z",
    "summary": "- Astrology: tap Posture for a current-year score chart (Calm→Alert bands, today marker, year mix)"
  },
  {
    "version": "3.14.0",
    "releasedAt": "2026-10-10T02:12:46.565Z",
    "summary": "- New Astrology tab with a live market-timing calendar: posture, lunar phase, active windows, and the next 90 days\n- Wheel-focused notes for eclipses, Mercury/Venus retrogrades, and major ingresses — pair with Market gauges, not a crystal ball"
  },
  {
    "version": "3.13.7",
    "releasedAt": "2026-10-09T17:13:47.776Z",
    "summary": "- Mobile Stocks History now loads own-ledger share buys/sells (same as web), so owned tickers show history instead of an empty sheet\n- Assignment-implied stock legs keep the option’s account so account-scoped history matches"
  },
  {
    "version": "3.13.6",
    "releasedAt": "2026-10-09T16:43:54.425Z",
    "summary": "- Close self-serve account creation; shared Create account / invite links no longer work\n- Clear outstanding email verify tokens used for new-account flows"
  },
  {
    "version": "3.13.5",
    "releasedAt": "2026-10-09T16:37:13.959Z",
    "summary": "- Analytics Tax Due card: “this month” badge sits at the top right; balance moves under the header."
  },
  {
    "version": "3.13.4",
    "releasedAt": "2026-10-09T16:35:57.824Z",
    "summary": "- Analytics ROC card: edit control sits next to Target; Realized and Target % align to the right."
  },
  {
    "version": "3.13.3",
    "releasedAt": "2026-10-09T04:05:25.312Z",
    "summary": "- Column pins keep sticking after silent table refreshes (settings pins were kept but sticky stopped until a full remount)."
  },
  {
    "version": "3.13.2",
    "releasedAt": "2026-10-09T03:58:56.142Z",
    "summary": "- Pinning a column no longer moves it to the left; pin only sticks it while scrolling.\n- Pin control sits to the right of the reorder arrows in column settings."
  },
  {
    "version": "3.13.1",
    "releasedAt": "2026-10-09T03:52:10.077Z",
    "summary": "- Column pins in settings stay saved across refresh and server sync (no more periodic reset).\n- Multiple pinned columns all stick on horizontal scroll, stacked from the left."
  },
  {
    "version": "3.13.0",
    "releasedAt": "2026-10-08T18:22:02.508Z",
    "summary": "- Paper agents: Cursor model Auto is now slot-aware — Sonnet on open/CC/near-expiry slots, Haiku on quiet manage-only slots (pins still force one model).\n- Existing agents switched to Auto so the new routing is active by default."
  },
  {
    "version": "3.12.0",
    "releasedAt": "2026-10-08T18:12:47.224Z",
    "summary": "- Paper agents: covered calls no longer blocked when the put book is full, and share-backed CCs no longer reserve cash collateral; failed opens now surface rejectionReason / skipReasons.\n- Token controls for all agents: candidate pack capped at 25, manage-only slots gate Allow Web, recycle defaults 30 runs / 1.5M tokens (token trigger needs ≥3 runs), memory default 3 turns with deduped feedback questions.\n- Prompt/system rules clarify Wheel stop-loss vs assignment, prefer book mids over stale web quotes, and recycle stays book-sync only (no closes)."
  },
  {
    "version": "3.11.1",
    "releasedAt": "2026-10-08T17:46:10.241Z",
    "summary": "- Make the Br and Ac columns 30% narrower across web and terminal tables, leaving more room for trade data."
  },
  {
    "version": "3.11.0",
    "releasedAt": "2026-10-03T17:52:29.677Z",
    "summary": "- Stocks (web and mobile) keep a separate strike-based avg cost per account; the same ticker in two live books is no longer blended.\n- Paper lots stay out of live avg cost, assignment companions, and Live-mode Stocks rows."
  },
  {
    "version": "3.10.34",
    "releasedAt": "2026-10-03T17:33:34.748Z",
    "summary": "- Header BP (web and mobile) now shows spendable cash equivalent instead of Robinhood’s overnight 2× buying power; hover still shows the RH figure."
  },
  {
    "version": "3.10.33",
    "releasedAt": "2026-10-03T16:21:44.082Z",
    "summary": "Call assignment P/L uses only that account’s share avg (paper lots no longer change live Robinhood assignment cost)."
  },
  {
    "version": "3.10.32",
    "releasedAt": "2026-10-02T22:37:40.409Z",
    "summary": "Call assignment P/L uses each account’s own strike-based avg cost (paper lots no longer change live Robinhood figures)."
  },
  {
    "version": "3.10.31",
    "releasedAt": "2026-10-02T21:45:57.474Z",
    "summary": "Mobile Performance Graph uses a taller viewBox and intrinsic sizing (~30% shorter than the stretched layout) instead of vertical stretch."
  },
  {
    "version": "3.10.30",
    "releasedAt": "2026-10-02T21:33:38.853Z",
    "summary": "Mobile Performance Graph fills its section and uses more vertical space."
  },
  {
    "version": "3.10.29",
    "releasedAt": "2026-10-02T21:31:57.950Z",
    "summary": "- Total Income on first Analytics open uses full history through the selected month (same window as Cash / Own Capital), not the current month alone."
  },
  {
    "version": "3.10.28",
    "releasedAt": "2026-10-02T20:57:15.231Z",
    "summary": "- Performance Graph zero line marks 0% on the percent axis, not $0."
  },
  {
    "version": "3.10.27",
    "releasedAt": "2026-10-02T20:53:51.803Z",
    "summary": "- Performance Graph shows a clear horizontal zero line and a bottom axis on the plot."
  },
  {
    "version": "3.10.26",
    "releasedAt": "2026-10-02T20:52:16.985Z",
    "summary": "- Performance Graph value card tracks the pointer under CSS zoom (no more drifting farther right)."
  },
  {
    "version": "3.10.25",
    "releasedAt": "2026-10-02T20:48:54.912Z",
    "summary": "- Performance Graph value card sits beside the pointer again (absolute, 20px right), without the broken fixed offset."
  },
  {
    "version": "3.10.24",
    "releasedAt": "2026-10-02T20:43:36.591Z",
    "summary": "- Performance Graph value card stays a fixed 20px to the right of the pointer across the whole chart."
  },
  {
    "version": "3.10.23",
    "releasedAt": "2026-10-02T20:32:51.303Z",
    "summary": "- Performance Graph value card stays ~20px to the right of the pointer, flipping left only near the right edge."
  },
  {
    "version": "3.10.22",
    "releasedAt": "2026-10-02T04:32:55.838Z",
    "summary": "- Total Income uses the monthly income layout, with the total beside the breakdown and the card tight to the text."
  },
  {
    "version": "3.10.21",
    "releasedAt": "2026-10-02T04:28:19.062Z",
    "summary": "- Total Income card hugs its two text columns, then is 3% wider than that."
  },
  {
    "version": "3.10.20",
    "releasedAt": "2026-10-02T04:18:56.068Z",
    "summary": "- Total Income card is 3% wider than the width of its text."
  },
  {
    "version": "3.10.19",
    "releasedAt": "2026-10-02T04:16:45.387Z",
    "summary": "- Performance Graph value card sits 1.1 card widths to the left of the pointer."
  },
  {
    "version": "3.10.18",
    "releasedAt": "2026-10-02T04:14:53.389Z",
    "summary": "- Total Income card is 3% wider."
  },
  {
    "version": "3.10.17",
    "releasedAt": "2026-10-02T04:13:52.793Z",
    "summary": "- Performance Graph percent axis fits ROC and S&P, including a small negative range."
  },
  {
    "version": "3.10.16",
    "releasedAt": "2026-10-02T04:11:49.750Z",
    "summary": "- Analytics cash card is labeled Cash."
  },
  {
    "version": "3.10.15",
    "releasedAt": "2026-10-02T04:10:56.614Z",
    "summary": "- S&P 500 on the Performance Graph stays flat through the forecast at the last closed month, so the line continues."
  },
  {
    "version": "3.10.14",
    "releasedAt": "2026-10-02T04:10:03.146Z",
    "summary": "- Total Income card hugs its total and breakdown instead of stretching a gap between them."
  },
  {
    "version": "3.10.13",
    "releasedAt": "2026-10-02T04:08:18.800Z",
    "summary": "- Performance Graph hover values stay on the chart, beside the month under the pointer."
  },
  {
    "version": "3.10.12",
    "releasedAt": "2026-10-02T04:06:01.184Z",
    "summary": "- Performance Graph shows call assignment losses, including expected assignment of open calls, and extends the dollar axis below zero."
  },
  {
    "version": "3.10.11",
    "releasedAt": "2026-10-02T04:04:50.241Z",
    "summary": "- Tapping the Analytics graph shows the month card and no longer reloads the page."
  },
  {
    "version": "3.10.10",
    "releasedAt": "2026-10-02T04:03:21.718Z",
    "summary": "- The Analytics graph keeps the month numbers card on touch, and the mobile chart is taller with a dollar axis on the left."
  },
  {
    "version": "3.10.9",
    "releasedAt": "2026-10-02T04:01:05.664Z",
    "summary": "- Performance Graph value card stays next to the pointer, on screen, instead of being cut off at the right edge."
  },
  {
    "version": "3.10.8",
    "releasedAt": "2026-10-02T03:34:25.307Z",
    "summary": "- Performance Graph keeps premiums, call assignment, and BTC cost in the forecast: planned income on premiums, and no planned assignment or buy-to-close."
  },
  {
    "version": "3.10.7",
    "releasedAt": "2026-10-02T03:30:04.109Z",
    "summary": "- Total Income card keeps its current width as a minimum, so the breakdown no longer spills out when the row gets narrower."
  },
  {
    "version": "3.10.6",
    "releasedAt": "2026-10-02T03:23:22.442Z",
    "summary": "- Performance Graph value card sits beside the cursor again."
  },
  {
    "version": "3.10.5",
    "releasedAt": "2026-10-02T03:21:35.782Z",
    "summary": "- Performance Graph month labels stay evenly spaced, so the forecast month no longer sits on the last closed month."
  },
  {
    "version": "3.10.4",
    "releasedAt": "2026-10-02T03:18:51.112Z",
    "summary": "- Performance Graph keeps forecast lines solid inside the shaded area, and draws ROC and S&P dotted."
  },
  {
    "version": "3.10.3",
    "releasedAt": "2026-10-02T03:16:18.774Z",
    "summary": "- Performance Graph hover card stays on the chart instead of sliding off the right edge."
  },
  {
    "version": "3.10.2",
    "releasedAt": "2026-10-02T03:12:18.171Z",
    "summary": "- Performance Graph uses new series colors, with Income, Premiums, ROC, BTC, Margin, and Own capital in that order."
  },
  {
    "version": "3.10.1",
    "releasedAt": "2026-10-02T03:10:44.813Z",
    "summary": "- Performance Graph draws the open month as a dotted forecast, not this month's results so far."
  },
  {
    "version": "3.10.0",
    "releasedAt": "2026-10-02T03:06:34.526Z",
    "summary": "- Performance Graph adds S&P 500 monthly return next to ROC for comparison."
  },
  {
    "version": "3.9.1",
    "releasedAt": "2026-10-01T23:13:37.555Z",
    "summary": "- Analytics day tables drop Symbol and keep Open and Exp wide enough for the full date."
  },
  {
    "version": "3.9.0",
    "releasedAt": "2026-10-01T23:08:22.386Z",
    "summary": "- Analytics day transactions show an Exp date beside Open."
  },
  {
    "version": "3.8.1",
    "releasedAt": "2026-10-01T23:03:45.491Z",
    "summary": "- Analytics day transactions fit the page when Compact is on."
  },
  {
    "version": "3.8.0",
    "releasedAt": "2026-10-01T21:15:19.908Z",
    "summary": "- Each login can connect its own Robinhood account. That connection is not shared.\n- When the market is closed, the Robinhood feed uses that login's snapshot."
  },
  {
    "version": "3.7.3",
    "releasedAt": "2026-10-01T20:33:40.560Z",
    "summary": "- A replaced Webull paper account no longer stays in the list next to its new account."
  },
  {
    "version": "3.7.2",
    "releasedAt": "2026-10-01T20:27:51.451Z",
    "summary": "- An open Webull paper position is imported even when Webull sends no order for it."
  },
  {
    "version": "3.7.1",
    "releasedAt": "2026-10-01T18:21:07.273Z",
    "summary": "- An account that only has paper books opens on Paper, so Webull paper cash is visible."
  },
  {
    "version": "3.7.0",
    "releasedAt": "2026-10-01T16:18:34.962Z",
    "summary": "- Webull paper accounts now refresh on their own.\n- Order history is read one year at a time, so a longer window no longer drops fills."
  },
  {
    "version": "3.6.24",
    "releasedAt": "2026-10-01T14:57:45.201Z",
    "summary": "Available shares are the shares not covered by open call contracts in the ledger."
  },
  {
    "version": "3.6.23",
    "releasedAt": "2026-10-01T14:28:24.552Z",
    "summary": "Options that still expire later are no longer recorded as assigned when a snapshot drops them."
  },
  {
    "version": "3.6.22",
    "releasedAt": "2026-09-30T23:03:52.941Z",
    "summary": "- Column sort arrows are orange and sit to the right of the column name."
  },
  {
    "version": "3.6.21",
    "releasedAt": "2026-09-30T22:54:00.378Z",
    "summary": "- The Analytics day list uses a chevron to collapse and expand, sitting on the Up to current month row."
  },
  {
    "version": "3.6.20",
    "releasedAt": "2026-09-30T22:53:00.488Z",
    "summary": "- The Analytics day list uses a chevron to collapse and expand, sitting on the Up to current month row."
  },
  {
    "version": "3.6.19",
    "releasedAt": "2026-09-30T22:49:17.128Z",
    "summary": "- Horizontal chart zoom keeps the latest data on the right edge of the window."
  },
  {
    "version": "3.6.18",
    "releasedAt": "2026-09-30T22:46:49.446Z",
    "summary": "- The colored line along the top of the bottom tab bar is gone."
  },
  {
    "version": "3.6.17",
    "releasedAt": "2026-09-30T22:45:49.774Z",
    "summary": "- Reset filters on Puts, Calls, Stocks, and Options returns the column sort to the default order."
  },
  {
    "version": "3.6.16",
    "releasedAt": "2026-09-30T22:44:04.165Z",
    "summary": "- Clicking a column header sorts the table, and Reset filters returns that sort to the default order."
  },
  {
    "version": "3.6.15",
    "releasedAt": "2026-09-30T22:36:45.835Z",
    "summary": "- The web reset button uses the same red as the mobile reset button."
  },
  {
    "version": "3.6.14",
    "releasedAt": "2026-09-30T22:32:45.630Z",
    "summary": "- Mobile no longer shows the colored lines under the top bar and above the bottom menu."
  },
  {
    "version": "3.6.13",
    "releasedAt": "2026-09-30T22:32:22.298Z",
    "summary": "- History no longer has a Deleted filter. Deleted cash stays out of the ledger view."
  },
  {
    "version": "3.6.12",
    "releasedAt": "2026-09-30T22:25:31.365Z",
    "summary": "- The bottom tab bar is a little taller."
  },
  {
    "version": "3.6.11",
    "releasedAt": "2026-09-30T22:23:43.598Z",
    "summary": "- The bottom tab bar is a little taller."
  },
  {
    "version": "3.6.10",
    "releasedAt": "2026-09-30T22:21:46.830Z",
    "summary": "- The bottom tab bar is slightly taller."
  },
  {
    "version": "3.6.9",
    "releasedAt": "2026-09-30T22:19:53.133Z",
    "summary": "- The bottom tab bar is full width and half as tall."
  },
  {
    "version": "3.6.8",
    "releasedAt": "2026-09-30T22:17:46.680Z",
    "summary": "- Web header connection indicators stay in one row."
  },
  {
    "version": "3.6.7",
    "releasedAt": "2026-09-30T22:16:25.053Z",
    "summary": "- The bottom tab bar is half as wide and stays centered."
  },
  {
    "version": "3.6.6",
    "releasedAt": "2026-09-30T22:16:12.691Z",
    "summary": "- Reset filters on every web tab is the same rose filter icon as on mobile."
  },
  {
    "version": "3.6.5",
    "releasedAt": "2026-09-30T22:14:37.557Z",
    "summary": "- Header connection indicators sit in two columns, side by side."
  },
  {
    "version": "3.6.4",
    "releasedAt": "2026-09-30T22:13:02.664Z",
    "summary": "- The Paper bottom tab bar is a deeper orange, with less yellow."
  },
  {
    "version": "3.6.3",
    "releasedAt": "2026-09-30T22:11:25.760Z",
    "summary": "- The bottom tab bar is StockForge+ blue in Live and orange in Paper."
  },
  {
    "version": "3.6.2",
    "releasedAt": "2026-09-30T22:04:30.593Z",
    "summary": "- History All years lists every transaction, not just the current month."
  },
  {
    "version": "3.6.1",
    "releasedAt": "2026-09-30T22:03:03.525Z",
    "summary": "- History reset also restores the default date sort."
  },
  {
    "version": "3.6.0",
    "releasedAt": "2026-09-30T22:01:34.029Z",
    "summary": "- Double-click a Shock watch or indicator card to open its history in a chart."
  },
  {
    "version": "3.5.48",
    "releasedAt": "2026-09-30T21:57:31.827Z",
    "summary": "- Analytics day transactions label Broker instead of System, and broker and account use the short display names in narrower columns."
  },
  {
    "version": "3.5.47",
    "releasedAt": "2026-09-30T21:45:17.391Z",
    "summary": "- Hovering an account card on the web shows the full broker and account name."
  },
  {
    "version": "3.5.46",
    "releasedAt": "2026-09-30T21:43:06.453Z",
    "summary": "- The bottom tab bar is blue in Live and gold in Paper."
  },
  {
    "version": "3.5.45",
    "releasedAt": "2026-09-30T21:42:47.938Z",
    "summary": "The mobile stock history table scrolls sideways inside its sheet so the right columns stay visible."
  },
  {
    "version": "3.5.44",
    "releasedAt": "2026-09-30T21:41:42.329Z",
    "summary": "A line sits under the mobile account bar, with less space before the content below."
  },
  {
    "version": "3.5.43",
    "releasedAt": "2026-09-30T21:40:38.353Z",
    "summary": "The mobile account label reads Accts in a slightly smaller font."
  },
  {
    "version": "3.5.42",
    "releasedAt": "2026-09-30T21:39:24.381Z",
    "summary": "Mobile History keeps the current month selected when All years is on, and shows that month's transactions."
  },
  {
    "version": "3.5.41",
    "releasedAt": "2026-09-30T21:19:48.521Z",
    "summary": "Mobile History opens on the latest month with trades and reloads the ledger so new transactions show."
  },
  {
    "version": "3.5.40",
    "releasedAt": "2026-09-30T21:10:09.362Z",
    "summary": "- The bottom tab bar picks up StockForge+ blue and orange shading."
  },
  {
    "version": "3.5.39",
    "releasedAt": "2026-09-30T19:32:02.124Z",
    "summary": "- The Live and Paper button is wider and stays the same width in both modes."
  },
  {
    "version": "3.5.38",
    "releasedAt": "2026-09-30T19:01:57.913Z",
    "summary": "- Account names on the cards match the smaller broker-mark type."
  },
  {
    "version": "3.5.37",
    "releasedAt": "2026-09-30T19:01:04.101Z",
    "summary": "- Selecting every account no longer snaps back to All on the last chip."
  },
  {
    "version": "3.5.36",
    "releasedAt": "2026-09-30T18:59:50.956Z",
    "summary": "- Account cards are shorter so the name row takes less vertical space."
  },
  {
    "version": "3.5.35",
    "releasedAt": "2026-09-30T18:56:24.123Z",
    "summary": "- Hovering an account card shows the full broker and account name, with Live or Paper in parentheses."
  },
  {
    "version": "3.5.34",
    "releasedAt": "2026-09-30T18:55:04.014Z",
    "summary": "- The account switch is labeled Accounts: instead of the shortened Accts."
  },
  {
    "version": "3.5.33",
    "releasedAt": "2026-09-30T18:53:36.060Z",
    "summary": "- Account cards are a little wider so the names are easier to read, and the Accts label stands out more."
  },
  {
    "version": "3.5.32",
    "releasedAt": "2026-09-30T18:49:07.236Z",
    "summary": "- The web tab menu sits along the bottom of the page, and it stays there while you scroll."
  },
  {
    "version": "3.5.31",
    "releasedAt": "2026-09-30T18:14:55.544Z",
    "summary": "Tabs open on the last saved view, then refresh in the background."
  },
  {
    "version": "3.5.30",
    "releasedAt": "2026-09-30T18:00:08.701Z",
    "summary": "- History columns scroll sideways, the same way as the other mobile tables."
  },
  {
    "version": "3.5.29",
    "releasedAt": "2026-09-30T01:59:06.792Z",
    "summary": "- History follows the Live/Paper switch, including which years and months still have trades."
  },
  {
    "version": "3.5.28",
    "releasedAt": "2026-09-30T01:48:51.819Z",
    "summary": "- The account strip scrolls, with the same end arrows when more accounts sit off either side."
  },
  {
    "version": "3.5.27",
    "releasedAt": "2026-09-30T01:46:47.191Z",
    "summary": "- The account strip scrolls, with the same end arrows when more accounts sit off either side."
  },
  {
    "version": "3.5.26",
    "releasedAt": "2026-09-30T01:43:39.692Z",
    "summary": "The Live/Paper switch changes its label and color when paper mode is on."
  },
  {
    "version": "3.5.25",
    "releasedAt": "2026-09-30T01:39:08.669Z",
    "summary": "Account chips show again beside the Live and Paper switch."
  },
  {
    "version": "3.5.24",
    "releasedAt": "2026-09-30T01:33:02.809Z",
    "summary": "Analytics card totals and the Market category list are back to how they were before the last few edits."
  },
  {
    "version": "3.5.23",
    "releasedAt": "2026-09-30T01:27:48.499Z",
    "summary": "Market categories show a vertical line under each group, and folding a top category hides the series under it."
  },
  {
    "version": "3.5.22",
    "releasedAt": "2026-09-30T01:16:55.751Z",
    "summary": "- The month Income card on Analytics-SF uses this month’s StockForge+ ledger income."
  },
  {
    "version": "3.5.21",
    "releasedAt": "2026-09-30T01:11:27.439Z",
    "summary": "- Analytics income, cost, own capital, and tax totals sit on the bottom edge of their cards."
  },
  {
    "version": "3.5.20",
    "releasedAt": "2026-09-30T01:01:46.386Z",
    "summary": "- Account switch is labeled Accts beside Live or Paper."
  },
  {
    "version": "3.5.19",
    "releasedAt": "2026-09-30T01:00:00.702Z",
    "summary": "- Tab and account overflow fades match the toolbar so the cut-off is visible."
  },
  {
    "version": "3.5.18",
    "releasedAt": "2026-09-30T00:57:56.435Z",
    "summary": "- The tab strip and account chips hide their scrollbars and fade either end when more is off-screen."
  },
  {
    "version": "3.5.17",
    "releasedAt": "2026-09-30T00:52:23.429Z",
    "summary": "- The web tab strip stays shorter, with a divider before the account picker."
  },
  {
    "version": "3.5.16",
    "releasedAt": "2026-09-29T20:14:52.760Z",
    "summary": "- Buying power follows the Live or Paper account selection on web and mobile.\n- Paper buying power is shown in orange."
  },
  {
    "version": "3.5.15",
    "releasedAt": "2026-09-29T20:03:30.236Z",
    "summary": "- Web account picker matches mobile: a Live or Paper switch, then chips for each account."
  },
  {
    "version": "3.5.14",
    "releasedAt": "2026-09-29T19:45:40.948Z",
    "summary": "- The account mode button reads Paper and Live."
  },
  {
    "version": "3.5.13",
    "releasedAt": "2026-09-29T19:43:54.124Z",
    "summary": "- The paper and live button lines up with the account chips."
  },
  {
    "version": "3.5.12",
    "releasedAt": "2026-09-29T19:41:10.475Z",
    "summary": "- The account button switches between paper and live. Paper mode puts a bright orange border around the app."
  },
  {
    "version": "3.5.11",
    "releasedAt": "2026-09-29T19:36:17.031Z",
    "summary": "- Account chips select several accounts in paper or live mode. Names are smaller and lowercase, and a long press shows the full account."
  },
  {
    "version": "3.5.10",
    "releasedAt": "2026-09-29T19:10:22.858Z",
    "summary": "- Mobile Options uses the same Paper and account chips, and broker and account values line up the same way on every tab."
  },
  {
    "version": "3.5.9",
    "releasedAt": "2026-09-29T18:59:39.941Z",
    "summary": "- Selected mobile account chips are orange for paper accounts and dark blue for live accounts."
  },
  {
    "version": "3.5.8",
    "releasedAt": "2026-09-29T18:57:34.400Z",
    "summary": "- Mobile Puts, Calls, Stocks, Analytics, History, and Import show a compact Paper button that selects every paper account, with account chips beside it."
  },
  {
    "version": "3.5.7",
    "releasedAt": "2026-09-29T14:50:51.132Z",
    "summary": "- Share history lists the event (Put assignment, stock buy, and so on) in its own column."
  },
  {
    "version": "3.5.6",
    "releasedAt": "2026-09-29T14:46:10.337Z",
    "summary": "- Share history dates stay on one line when a stock position is unfolded."
  },
  {
    "version": "3.5.5",
    "releasedAt": "2026-09-29T14:30:45.274Z",
    "summary": "- Options column headers sort the open-positions table.\n- Click again to reverse the order, and a third time to restore it."
  },
  {
    "version": "3.5.4",
    "releasedAt": "2026-09-29T14:21:29.512Z",
    "summary": "- Analytics day history has a control to collapse or expand every day at once."
  },
  {
    "version": "3.5.3",
    "releasedAt": "2026-09-29T02:23:07.402Z",
    "summary": "- The Webull header light stays hidden until you are signed in."
  },
  {
    "version": "3.5.2",
    "releasedAt": "2026-09-29T02:20:57.761Z",
    "summary": "- A Webull light sits with the other header indicators and turns green when paper is connected."
  },
  {
    "version": "3.5.1",
    "releasedAt": "2026-09-29T00:25:20.495Z",
    "summary": "- Analytics day tables are wide enough to show dates, credits, and P/L without clipping."
  },
  {
    "version": "3.5.0",
    "releasedAt": "2026-09-29T00:13:17.797Z",
    "summary": "- Paper trading agents now book each fill onto their paper ledger account.\n- Positions, stocks, history, and analytics follow that account, or all paper accounts."
  },
  {
    "version": "3.4.9",
    "releasedAt": "2026-09-29T00:06:15.807Z",
    "summary": "- Paper monthly income no longer subtracts Robinhood's live margin interest."
  },
  {
    "version": "3.4.8",
    "releasedAt": "2026-09-28T20:51:18.536Z",
    "summary": "- Webull Desktop stays directly behind the terminal window, so clicking the cell keeps the two stacked together."
  },
  {
    "version": "3.4.7",
    "releasedAt": "2026-09-28T20:19:10.061Z",
    "summary": "Webull Desktop locks into the terminal cell using the Accessibility permission already granted to StockForgePlus terminal."
  },
  {
    "version": "3.4.6",
    "releasedAt": "2026-09-28T20:04:28.866Z",
    "summary": "Webull Desktop stays in the terminal cell after you allow StockForgePlus terminal in Privacy & Security, Accessibility."
  },
  {
    "version": "3.4.5",
    "releasedAt": "2026-09-28T20:00:08.034Z",
    "summary": "Webull Desktop stays locked in the terminal cell. Allow StockForgePlus terminal under Privacy & Security, Accessibility, when macOS asks."
  },
  {
    "version": "3.4.4",
    "releasedAt": "2026-09-28T19:48:10.066Z",
    "summary": "Webull Desktop stays locked in the terminal cell instead of freezing after the first move."
  },
  {
    "version": "3.4.3",
    "releasedAt": "2026-09-28T19:42:10.229Z",
    "summary": "Maintenance release."
  },
  {
    "version": "3.4.2",
    "releasedAt": "2026-09-28T19:39:09.842Z",
    "summary": "Webull Desktop stays locked in the terminal cell if the window drifts out."
  },
  {
    "version": "3.4.1",
    "releasedAt": "2026-09-28T19:13:59.023Z",
    "summary": "Command-plus and Command-minus zoom Webull Desktop when that pane is in use."
  },
  {
    "version": "3.4.0",
    "releasedAt": "2026-09-28T19:03:42.175Z",
    "summary": "The Mac terminal Webull button chooses Web or Desktop.\nDesktop is unavailable unless the Webull Desktop app is installed."
  },
  {
    "version": "3.3.1",
    "releasedAt": "2026-09-28T18:55:59.328Z",
    "summary": "Webull Desktop follows the terminal cell while the window is dragged."
  },
  {
    "version": "3.3.0",
    "releasedAt": "2026-09-28T18:37:53.757Z",
    "summary": "The Mac terminal Webull cell opens the Webull Desktop app in that pane.\nThe desktop window stays fitted to the cell when the terminal window or the cell is resized."
  },
  {
    "version": "3.2.17",
    "releasedAt": "2026-09-28T18:09:19.643Z",
    "summary": "- Webull stays fitted in the cell after the terminal window or the cell is resized."
  },
  {
    "version": "3.2.16",
    "releasedAt": "2026-09-28T17:59:06.679Z",
    "summary": "- Webull’s trading layout, including the order ticket and account column, scales into the cell."
  },
  {
    "version": "3.2.15",
    "releasedAt": "2026-09-28T17:55:26.016Z",
    "summary": "The Mac terminal Webull pane opens the current paper trade screen and leaves the legacy paper page."
  },
  {
    "version": "3.2.14",
    "releasedAt": "2026-09-28T17:40:29.959Z",
    "summary": "The Mac terminal Webull pane opens the same paper page as the browser, app.webull.com/paper."
  },
  {
    "version": "3.2.13",
    "releasedAt": "2026-09-28T17:19:36.184Z",
    "summary": "Paper buying power in the top bar follows the selected paper accounts and is shown in orange."
  },
  {
    "version": "3.2.12",
    "releasedAt": "2026-09-28T15:45:42.328Z",
    "summary": "- Webull filter submenus open beside the item and stay inside the pane."
  },
  {
    "version": "3.2.11",
    "releasedAt": "2026-09-28T15:24:14.812Z",
    "summary": "- Webull account and profile menus stay inside the pane."
  },
  {
    "version": "3.2.10",
    "releasedAt": "2026-09-28T14:48:45.287Z",
    "summary": "- Webull Google and Apple sign-in stays in the terminal, so approval returns to the pane.\n- Webull’s title bar stays aligned with the trading page."
  },
  {
    "version": "3.2.9",
    "releasedAt": "2026-09-28T14:39:25.233Z",
    "summary": "- Webull sign-in stays fully visible in the terminal, and Google or Apple sign-in opens in an app window.\n- Webull’s title bar stays aligned with the trading page."
  },
  {
    "version": "3.2.8",
    "releasedAt": "2026-09-28T14:26:55.258Z",
    "summary": "- Put recommendations stay listed when paper accounts are on."
  },
  {
    "version": "3.2.7",
    "releasedAt": "2026-09-28T14:00:44.962Z",
    "summary": "- Import shows one row when a Robinhood fill was also detected as a position change.\n- An expiration marked earlier is not listed again when settlement arrives the same day."
  },
  {
    "version": "3.2.6",
    "releasedAt": "2026-09-28T01:31:09.943Z",
    "summary": "- Webull’s top bar scales with the page so it stays aligned in the pane."
  },
  {
    "version": "3.2.5",
    "releasedAt": "2026-09-28T01:23:11.436Z",
    "summary": "- Command-+ on Webull enlarges the type while the trading page stays inside the pane."
  },
  {
    "version": "3.2.4",
    "releasedAt": "2026-09-28T01:14:07.158Z",
    "summary": "- Command-+ on a Webull pane stops at the frame so the quote column is not clipped."
  },
  {
    "version": "3.2.3",
    "releasedAt": "2026-09-27T18:19:23.073Z",
    "summary": "- Webull in the terminal scales to its pane so the quote column stays inside the frame."
  },
  {
    "version": "3.2.2",
    "releasedAt": "2026-09-27T18:01:05.655Z",
    "summary": "- Webull in the terminal scales to the pane so the watchlist is not cut off."
  },
  {
    "version": "3.2.1",
    "releasedAt": "2026-09-27T17:51:36.405Z",
    "summary": "- StockForge+ in the terminal title bar uses the original blue again."
  },
  {
    "version": "3.2.0",
    "releasedAt": "2026-09-27T17:41:59.190Z",
    "summary": "The terminal title bar loads Webull, colored in Webull blue, instead of the Legend menu."
  },
  {
    "version": "3.1.3",
    "releasedAt": "2026-09-27T17:28:43.663Z",
    "summary": "- Analytics in paper mode shows only paper trades and cash."
  },
  {
    "version": "3.1.2",
    "releasedAt": "2026-09-27T17:22:36.528Z",
    "summary": "- Logout button styling is restored."
  },
  {
    "version": "3.1.1",
    "releasedAt": "2026-09-27T17:21:53.026Z",
    "summary": "- Tax stays unavailable while paper accounts are on."
  },
  {
    "version": "3.1.0",
    "releasedAt": "2026-09-27T17:12:45.411Z",
    "summary": "- Webull paper margin and cash history is written into the own ledger\n- Those books show on the same tabs as the other accounts"
  },
  {
    "version": "3.0.6",
    "releasedAt": "2026-09-27T16:55:23.780Z",
    "summary": "- Accounts no longer lists crypto, events cash, or futures books."
  },
  {
    "version": "3.0.5",
    "releasedAt": "2026-09-27T16:50:09.517Z",
    "summary": "- Accounts is the selected-tab blue for live books, and orange when Paper accs is on."
  },
  {
    "version": "3.0.4",
    "releasedAt": "2026-09-27T16:48:33.086Z",
    "summary": "- The Accounts selector uses the same orange accent as the compact button beside it."
  },
  {
    "version": "3.0.3",
    "releasedAt": "2026-09-27T16:42:04.088Z",
    "summary": "- Account menu rows line up on the left: the paper switch, All, broker names, and accounts."
  },
  {
    "version": "3.0.2",
    "releasedAt": "2026-09-27T16:39:33.683Z",
    "summary": "- Accounts uses the same type as the tab headers.\n- The paper switch is orange, matching the accent control beside it."
  },
  {
    "version": "3.0.1",
    "releasedAt": "2026-09-27T16:07:04.487Z",
    "summary": "- The account filter is one menu, with a Paper accs switch at the top.\n- All shows every account in that mode. Paper on lists only paper accounts."
  },
  {
    "version": "3.0.0",
    "releasedAt": "2026-09-27T15:49:59.381Z",
    "summary": "- Brokers and Accounts on the tab bar filter Options, Puts, Calls, Stocks, History, Tax, and Import.\n- Paper accounts stay hidden until Paper accs is on, and Tax keeps that switch off."
  },
  {
    "version": "2.33.2",
    "releasedAt": "2026-09-26T23:22:42.374Z",
    "summary": "- Robinhood import stays on a Robinhood account\n- Copied Robinhood cash was removed from the Webull paper account"
  },
  {
    "version": "2.33.1",
    "releasedAt": "2026-09-26T23:10:06.281Z",
    "summary": "- Webull paper keys can be saved from Settings\n- The key and secret fields use the full width of the card"
  },
  {
    "version": "2.33.0",
    "releasedAt": "2026-09-26T22:08:35.110Z",
    "summary": "- Connect a Webull paper account in Settings and register its accounts on your ledger\n- Each StockForge+ user keeps their own paper keys"
  },
  {
    "version": "2.32.0",
    "releasedAt": "2026-09-25T20:48:49.609Z",
    "summary": "- Recession blend now includes lending standards, permit growth, core capital-goods orders, and consumer sentiment.\n- History charts are grouped: rates, credit and lending, the real economy, labor, and market stress."
  },
  {
    "version": "2.31.14",
    "releasedAt": "2026-09-25T19:51:01.946Z",
    "summary": "- Full screen on a Market chart covers the Mac terminal and hides the other grid panes until you leave it."
  },
  {
    "version": "2.31.13",
    "releasedAt": "2026-09-25T19:24:49.609Z",
    "summary": "- Zooming a Market chart popup stretches only the width. The chart height stays put."
  },
  {
    "version": "2.31.12",
    "releasedAt": "2026-09-25T19:21:36.494Z",
    "summary": "- The recession blend popup has the same All, 5 years, 1 year, and 1 quarter switch as the chart on the page."
  },
  {
    "version": "2.31.11",
    "releasedAt": "2026-09-25T19:18:29.474Z",
    "summary": "- The 12-month NY Fed percent is labeled Recession chances."
  },
  {
    "version": "2.31.10",
    "releasedAt": "2026-09-25T19:17:44.438Z",
    "summary": "- Danger-line labels on the recession blend use a small font and sit in the empty next-12-months sleeve."
  },
  {
    "version": "2.31.9",
    "releasedAt": "2026-09-25T19:16:35.709Z",
    "summary": "- The yellow band on Market charts is the three months before a recession, and it is no longer listed in the legend."
  },
  {
    "version": "2.31.8",
    "releasedAt": "2026-09-25T19:15:53.939Z",
    "summary": "- Market chart hover labels and info tooltips use a larger font."
  },
  {
    "version": "2.31.7",
    "releasedAt": "2026-09-25T19:14:25.124Z",
    "summary": "- Market tab text is one step larger. Year labels on the charts stay small."
  },
  {
    "version": "2.31.6",
    "releasedAt": "2026-09-25T19:13:14.001Z",
    "summary": "- Year labels on the Market charts are smaller, with a dotted line at each year. Month lines appear on the shorter windows."
  },
  {
    "version": "2.31.5",
    "releasedAt": "2026-09-25T19:11:08.863Z",
    "summary": "- A Market chart opened in the popup keeps its legend, including the line switches."
  },
  {
    "version": "2.31.4",
    "releasedAt": "2026-09-25T19:10:02.030Z",
    "summary": "- A card's reading versus its danger level turns red when that reading means a recession is likely."
  },
  {
    "version": "2.31.3",
    "releasedAt": "2026-09-25T19:08:28.469Z",
    "summary": "- Market chart lines stay thin, including when a chart fills the screen."
  },
  {
    "version": "2.31.2",
    "releasedAt": "2026-09-25T19:07:24.003Z",
    "summary": "- Each indicator card shows its reading next to the danger level, the same way Shock watch does."
  },
  {
    "version": "2.31.1",
    "releasedAt": "2026-09-25T19:05:52.918Z",
    "summary": "- The 4–8 week Market score shows how far it sits from the cut line, not a recession percent.\n- Shock watch sits on one row, and the indicator tiles fit on two."
  },
  {
    "version": "2.31.0",
    "releasedAt": "2026-09-25T18:27:58.379Z",
    "summary": "- Right-click a Market chart to open it in a popup, then zoom or fill the screen."
  },
  {
    "version": "2.30.2",
    "releasedAt": "2026-09-25T18:20:22.731Z",
    "summary": "- Hovering a market chart slides a vertical strip to that month and shows the month and year."
  },
  {
    "version": "2.30.1",
    "releasedAt": "2026-09-25T18:17:16.560Z",
    "summary": "- Indicator charts share one time scale, so the same recession lines up across them."
  },
  {
    "version": "2.30.0",
    "releasedAt": "2026-09-25T18:15:07.293Z",
    "summary": "- The recession blend chart has a 5-year window.\n- Each indicator's danger level is a dotted line in that indicator's color, and it hides with the indicator.\n- Each indicator chart shades the safe, tight, and danger regions."
  },
  {
    "version": "2.29.2",
    "releasedAt": "2026-09-25T18:08:12.166Z",
    "summary": "- Paper agents book each fill to their own account, named for the agent color, such as paper_agent_blue."
  },
  {
    "version": "2.29.1",
    "releasedAt": "2026-09-25T18:07:41.580Z",
    "summary": "- Recession months on the Market charts are a brighter red, and the 12 months before each recession are yellow."
  },
  {
    "version": "2.29.0",
    "releasedAt": "2026-09-25T18:07:05.095Z",
    "summary": "- Paper agents book trades to their own accounts, named like paper_agent_blue, instead of a live brokerage account."
  },
  {
    "version": "2.28.5",
    "releasedAt": "2026-09-25T17:58:46.593Z",
    "summary": "- The open DLTR call shows the Robinhood account it was sold in.\n- Agentic opens and closes keep that broker account instead of landing on an empty one."
  },
  {
    "version": "2.28.4",
    "releasedAt": "2026-09-25T17:45:08.840Z",
    "summary": "- The All scope label now reads “Up to current month.”"
  },
  {
    "version": "2.28.3",
    "releasedAt": "2026-09-25T17:31:52.727Z",
    "summary": "- With forecast off, All Years own capital is the current month, using accrued margin instead of the forecast through 2031."
  },
  {
    "version": "2.28.2",
    "releasedAt": "2026-09-25T17:16:52.402Z",
    "summary": "Terminal sign-in opens the browser so macOS Passwords can fill the account, then signs the terminal in."
  },
  {
    "version": "2.28.1",
    "releasedAt": "2026-09-25T17:01:38.127Z",
    "summary": "Settings Mac download shows when that terminal build was published."
  },
  {
    "version": "2.28.0",
    "releasedAt": "2026-09-25T16:57:30.648Z",
    "summary": "- Analytics has an account row with broker and short name, and Total Income follows the account you pick.\n- Each analytics trade keeps its broker and account next to the amount, even when the rest of the line is clipped."
  },
  {
    "version": "2.27.5",
    "releasedAt": "2026-09-25T16:52:13.471Z",
    "summary": "- All Years total own capital is the current month balance, not the March 2031 forecast."
  },
  {
    "version": "2.27.4",
    "releasedAt": "2026-09-25T16:49:07.000Z",
    "summary": "Mobile History uses the own ledger, so broker and account marks show on the same trades as web History."
  },
  {
    "version": "2.27.3",
    "releasedAt": "2026-09-25T16:41:15.054Z",
    "summary": "- The recession blend chart no longer repeats the NBER and Indicator legend."
  },
  {
    "version": "2.27.2",
    "releasedAt": "2026-09-25T16:40:47.263Z",
    "summary": "Analytics, Focus, Agentic, Import, and Calls+ show the broker badge and account short name on every position and transaction list."
  },
  {
    "version": "2.27.1",
    "releasedAt": "2026-09-25T16:40:02.396Z",
    "summary": "- Market no longer reloads with the live quote timer, so the chart window and scroll stay put."
  },
  {
    "version": "2.27.0",
    "releasedAt": "2026-09-25T16:34:44.151Z",
    "summary": "- Stocks shows the broker badge and account short name on each share holding, same as Options, Puts, Calls, and History."
  },
  {
    "version": "2.26.4",
    "releasedAt": "2026-09-25T16:28:43.723Z",
    "summary": "- Terminal and web sign-in is a real login form, so the password manager can fill and save email and password."
  },
  {
    "version": "2.26.3",
    "releasedAt": "2026-09-25T16:28:34.805Z",
    "summary": "- Mobile Options and Stocks show the broker badge and account short name, same as Puts, Calls, and History."
  },
  {
    "version": "2.26.2",
    "releasedAt": "2026-09-25T16:22:09.485Z",
    "summary": "- The blend chart's next 12 months sit on the real time scale, with All, 1 year, and 1 quarter windows you can scroll."
  },
  {
    "version": "2.26.1",
    "releasedAt": "2026-09-25T16:15:03.643Z",
    "summary": "- Indicators use the same colored tiles as shock watch, including a Risk tile with the chart's latest chance."
  },
  {
    "version": "2.26.0",
    "releasedAt": "2026-09-25T16:12:07.427Z",
    "summary": "- Options shows the broker badge and account short name on each open contract.\n- Options opens the position table without waiting on stalled quote or probability calls."
  },
  {
    "version": "2.25.6",
    "releasedAt": "2026-09-25T16:11:49.335Z",
    "summary": "- Shock watch tiles open their explanation in a modal from an info button."
  },
  {
    "version": "2.25.5",
    "releasedAt": "2026-09-25T16:11:18.121Z",
    "summary": "- Mobile sign-in stays put on refresh, and iOS can autofill email and password."
  },
  {
    "version": "2.25.4",
    "releasedAt": "2026-09-25T16:05:05.332Z",
    "summary": "- Shock watch is two rows of tiles, colored by Safe, Tight, or Watch, with the explanation in a tooltip."
  },
  {
    "version": "2.25.3",
    "releasedAt": "2026-09-25T15:25:56.876Z",
    "summary": "- Recession blend chart is taller, with thinner lines."
  },
  {
    "version": "2.25.2",
    "releasedAt": "2026-09-25T15:24:31.568Z",
    "summary": "- Market chart legend stays in a row, and a hidden line stays as a dimmed legend item."
  },
  {
    "version": "2.25.1",
    "releasedAt": "2026-09-25T15:11:35.285Z",
    "summary": "- Market chart legends have an info button that explains what each line shows."
  },
  {
    "version": "2.25.0",
    "releasedAt": "2026-09-25T15:04:13.345Z",
    "summary": "- The recession blend chart can hide each line, and adds an orange Risk line for the chance a recession is underway or starts within 12 months."
  },
  {
    "version": "2.24.2",
    "releasedAt": "2026-09-25T14:59:15.664Z",
    "summary": "- Indicator rows and charts show Safe, Tight, or Watch for the latest reading."
  },
  {
    "version": "2.24.1",
    "releasedAt": "2026-09-25T14:54:37.161Z",
    "summary": "- Shock watch cards show the live reading against the tripwire, labeled Safe, Tight, or Watch."
  },
  {
    "version": "2.24.0",
    "releasedAt": "2026-09-25T14:39:24.407Z",
    "summary": "- Market tab adds a recession blend chart that ranks the curve, credit, financial conditions, and Sahm gap together and marks the next 12 months when that blend is in the pre-recession band."
  },
  {
    "version": "2.23.0",
    "releasedAt": "2026-09-25T14:34:18.275Z",
    "summary": "- History, Puts, and Calls show a narrow broker badge and account code on web and mobile.\n- Broker and account columns can be hidden or moved in column settings.\n- Each account has a Short name in Settings, filled from the account name so you can rename the code."
  },
  {
    "version": "2.22.2",
    "releasedAt": "2026-09-25T14:27:58.067Z",
    "summary": "- Shock watch rows have an info button explaining the gauge, how the tripwire works, and normal versus dangerous readings."
  },
  {
    "version": "2.22.1",
    "releasedAt": "2026-09-25T14:13:42.273Z",
    "summary": "- Fix Market tab text layout that dropped the summary sentence style."
  },
  {
    "version": "2.22.0",
    "releasedAt": "2026-09-25T14:12:35.666Z",
    "summary": "- Market tab on web and mobile with a weeks-ahead stress score and the NY Fed 12-month recession chance.\n- Named indicators with long charts through NBER recessions, plus a shock watch for funding, credit, oil, policy, and volatility.\n- Gauges refresh analytically from FRED on a schedule. No agent writes the reading."
  },
  {
    "version": "2.21.0",
    "releasedAt": "2026-09-25T13:22:08.648Z",
    "summary": "Quote changes show a fading +/- badge, and the income chart draws forecast months as dotted lines.\nRobinhood USDC deposits and withdrawals import into cash, and closed months use own-capital margin when snapshots are missing.\nOption premiums round so filled opens are not dropped on import."
  },
  {
    "version": "2.20.24",
    "releasedAt": "2026-09-25T13:15:01.011Z",
    "summary": "Switching an advisor Off stops advice runs and removes its Cursor cloud agent.\nRun advice and Recycle stay disabled until the advisor is turned back On."
  },
  {
    "version": "2.20.23",
    "releasedAt": "2026-09-25T00:58:49.208Z",
    "summary": "- Feed ring stays full and pulses until the refresh finishes, then starts empty\n- A completed countdown no longer clears early and jumps back to a full pulsing ring"
  },
  {
    "version": "2.20.22",
    "releasedAt": "2026-09-25T00:55:08.576Z",
    "summary": "- Feed ring pulses in its feed color for the whole refresh, then clears\n- A finished countdown no longer stays as a solid ring after the update"
  },
  {
    "version": "2.20.21",
    "releasedAt": "2026-09-25T00:48:48.898Z",
    "summary": "- Header feed mark is a color circle only, sitting at the right of the title\n- The circle fills and pulses in the Robinhood or StockForge color while data refreshes"
  },
  {
    "version": "2.20.20",
    "releasedAt": "2026-09-25T00:39:03.423Z",
    "summary": "- Off hours the header feed stays on Robinhood instead of flipping to StockForge\n- A Robinhood status recheck no longer marks the connection as dropped"
  },
  {
    "version": "2.20.19",
    "releasedAt": "2026-09-25T00:35:22.201Z",
    "summary": "- Robin refresh ring completes once, then stays steady on Calls, Puts, Options, Focus, and Stocks\n- A finished countdown no longer retriggers quote reloads and ring flashes every second"
  },
  {
    "version": "2.20.18",
    "releasedAt": "2026-09-25T00:24:08.475Z",
    "summary": "- Analytics keeps finished months on the device and rebuilds them only when the ledger or month plans change."
  },
  {
    "version": "2.20.17",
    "releasedAt": "2026-09-25T00:21:36.660Z",
    "summary": "- Analytics reuses a cached month until the ledger changes, so past months and forecasts open faster."
  },
  {
    "version": "2.20.16",
    "releasedAt": "2026-09-25T00:12:21.199Z",
    "summary": "- The Robinhood feed mark in the top bar reads robin»."
  },
  {
    "version": "2.20.15",
    "releasedAt": "2026-09-25T00:11:40.485Z",
    "summary": "- The feed mark sits in the top bar, smaller, and reads Robin» or sf."
  },
  {
    "version": "2.20.14",
    "releasedAt": "2026-09-24T23:42:29.586Z",
    "summary": "- Agentic open positions scroll sideways like the Options table, with held ROC and the row menu kept as extra columns."
  },
  {
    "version": "2.20.13",
    "releasedAt": "2026-09-24T23:36:10.345Z",
    "summary": "- Ticker filters share one width and use the shorter Tikr label."
  },
  {
    "version": "2.20.12",
    "releasedAt": "2026-09-24T21:31:07.440Z",
    "summary": "- Analytics reset turns Forecast off and returns to the current year and month."
  },
  {
    "version": "2.20.11",
    "releasedAt": "2026-09-24T21:30:08.413Z",
    "summary": "- Analytics hides future years and months while Forecast is off."
  },
  {
    "version": "2.20.10",
    "releasedAt": "2026-09-24T21:28:35.029Z",
    "summary": "- Mobile filters use the StockForge+ blue instead of orange.\n- Stocks show filters are about half as wide."
  },
  {
    "version": "2.20.9",
    "releasedAt": "2026-09-24T21:26:51.782Z",
    "summary": "- Checked Use Forecast on a future month applies the current month's margin cost."
  },
  {
    "version": "2.20.8",
    "releasedAt": "2026-09-24T21:25:15.353Z",
    "summary": "- Future forecast months keep Use Forecast on and apply the current month's margin cost."
  },
  {
    "version": "2.20.7",
    "releasedAt": "2026-09-24T21:23:35.946Z",
    "summary": "- Future forecast months default to the current month's margin cost when Use Forecast is on."
  },
  {
    "version": "2.20.6",
    "releasedAt": "2026-09-24T21:22:19.007Z",
    "summary": "- Turning Forecast off returns Analytics to the current year and month.\n- Future months show Use Forecast on the cost card, and a checked box uses the current month's margin cost."
  },
  {
    "version": "2.20.5",
    "releasedAt": "2026-09-24T21:16:09.747Z",
    "summary": "- Analytics reset returns the view to the current year and month."
  },
  {
    "version": "2.20.4",
    "releasedAt": "2026-09-24T21:14:37.539Z",
    "summary": "- Analytics reset returns the view to the current year and month."
  },
  {
    "version": "2.20.3",
    "releasedAt": "2026-09-24T21:11:02.608Z",
    "summary": "- Mobile Options, Puts, Calls, Stocks, and Analytics use the same red clear-filters button.\n- Options and Stocks ticker fields are narrower, and the Stocks show control is tighter."
  },
  {
    "version": "2.20.2",
    "releasedAt": "2026-09-24T15:49:59.173Z",
    "summary": "- Mobile History reset button shows a filter with an X."
  },
  {
    "version": "2.20.1",
    "releasedAt": "2026-09-24T15:49:03.770Z",
    "summary": "- Mobile History reset control uses a clear-filters icon."
  },
  {
    "version": "2.20.0",
    "releasedAt": "2026-09-24T15:38:48.788Z",
    "summary": "- Mobile History shows cash movements (deposits, withdrawals, interest, transfers) alongside trades.\n- History filters include Cash, a narrower ticker box, and a reset button."
  },
  {
    "version": "2.19.8",
    "releasedAt": "2026-09-23T22:43:19.903Z",
    "summary": "- Note icon on type badges is shaded white so it reads on the colored pills."
  },
  {
    "version": "2.19.7",
    "releasedAt": "2026-09-23T22:40:48.842Z",
    "summary": "- Transactions with a note show a tiny notepad icon on the type badge instead of an *i*."
  },
  {
    "version": "2.19.6",
    "releasedAt": "2026-09-23T22:37:54.455Z",
    "summary": "- Note marker on type badges stays a lowercase *i* instead of an uppercase I."
  },
  {
    "version": "2.19.5",
    "releasedAt": "2026-09-23T21:47:57.209Z",
    "summary": "- Note *i* on type badges uses the same bright blue as the StockForge wordmark."
  },
  {
    "version": "2.19.4",
    "releasedAt": "2026-09-23T21:35:54.602Z",
    "summary": "- Note *i* on History and Analytics type badges is larger so it is easier to see."
  },
  {
    "version": "2.19.3",
    "releasedAt": "2026-09-23T21:11:10.172Z",
    "summary": "- Note marker on History and Analytics type badges is a deep-blue *i*."
  },
  {
    "version": "2.19.2",
    "releasedAt": "2026-09-23T20:51:58.535Z",
    "summary": "- History and Analytics type badges keep their original colors; a small *i* appears only on transactions that have a user note."
  },
  {
    "version": "2.19.1",
    "releasedAt": "2026-09-23T20:33:21.581Z",
    "summary": "- History and Analytics now keep saved transaction notes on the type badge after refresh."
  },
  {
    "version": "2.19.0",
    "releasedAt": "2026-09-23T20:30:06.731Z",
    "summary": "- Click a transaction type badge in History or Analytics to add a note; hover shows the text, and a gold dot marks rows that have one."
  },
  {
    "version": "2.18.13",
    "releasedAt": "2026-09-23T20:18:55.098Z",
    "summary": "- Analytics day history keeps a header on every date, with the same column widths so they line up."
  },
  {
    "version": "2.18.12",
    "releasedAt": "2026-09-23T20:16:33.187Z",
    "summary": "- Analytics day-history columns now share one fixed grid so Type / Credit / Symbol line up under the header on every date."
  },
  {
    "version": "2.18.11",
    "releasedAt": "2026-09-23T20:14:24.708Z",
    "summary": "Analytics day-history columns stay lined up under one header, instead of a separate floating header under each date."
  },
  {
    "version": "2.18.10",
    "releasedAt": "2026-09-23T20:08:40.858Z",
    "summary": "History now shows yesterday’s $2,650 Robinhood ACH and today’s $3,945 as two deposits, instead of one combined pending amount."
  },
  {
    "version": "2.18.9",
    "releasedAt": "2026-09-23T19:50:31.346Z",
    "summary": "Yesterday’s Robinhood ACH now shows on that day in History and Analytics, instead of the day import first saw the pending amount."
  },
  {
    "version": "2.18.8",
    "releasedAt": "2026-09-23T19:41:01.909Z",
    "summary": "Robinhood pending ACH deposits and withdrawals now land in History and Analytics cash, instead of staying only on the brokerage portfolio.\nThe last two days of account cash were missing because import never read those pending amounts from Robinhood."
  },
  {
    "version": "2.18.7",
    "releasedAt": "2026-09-21T18:02:38.601Z",
    "summary": "- Mobile top bar puts BP left of the RH/AG/Proxy stack, with a little space before the action icons and slightly smaller status type."
  },
  {
    "version": "2.18.6",
    "releasedAt": "2026-09-21T16:58:11.280Z",
    "summary": "- Book the LULU Nov 20 $115 covered calls that import dropped, so those shares show as bound.\n- Keep option premiums rounded so a $1.60 fill no longer overflows the import key and gets skipped."
  },
  {
    "version": "2.18.5",
    "releasedAt": "2026-09-21T01:24:55.650Z",
    "summary": "- Make the mobile top-bar refresh, settings, and logout buttons a bit smaller."
  },
  {
    "version": "2.18.4",
    "releasedAt": "2026-09-21T01:23:50.363Z",
    "summary": "- Shrink the mobile top-bar RH/AG/Proxy pills and the BP tile so they take less width."
  },
  {
    "version": "2.18.3",
    "releasedAt": "2026-09-21T01:22:46.316Z",
    "summary": "- Move the mobile market-status dot to the right of the StockForge+ wordmark."
  },
  {
    "version": "2.18.2",
    "releasedAt": "2026-09-21T01:20:29.049Z",
    "summary": "- Mobile market status is now a color dot next to the logo instead of an Open/Closed pill."
  },
  {
    "version": "2.18.1",
    "releasedAt": "2026-09-21T01:14:31.467Z",
    "summary": "- Tighten the mobile top bar so the brand, stacked RH/AG/Proxy pills, and BP amount all fit on a phone-width screen."
  },
  {
    "version": "2.18.0",
    "releasedAt": "2026-09-21T01:13:37.251Z",
    "summary": "- Mobile top bar stacks RH, AG, and Proxy in a vertical column so they take less width.\n- Mobile now shows Robinhood buying power as BP: $X in the top bar, same as web; tap it to open Import."
  },
  {
    "version": "2.17.1",
    "releasedAt": "2026-09-14T20:23:27.968Z",
    "summary": "Analytics(L) planned Return on capital now keeps the % you saved instead of snapping back to 6%.\nSaving cash or expenses no longer overwrites that target with the 6% default.\nForecast months inherit the last real target across year-end instead of resetting to 6%."
  },
  {
    "version": "2.17.0",
    "releasedAt": "2026-09-14T18:34:36.520Z",
    "summary": "Show Robinhood buying power as BP: $X on the right of the web top bar.\nClick it to open Import; it tracks the active account from the latest snapshot."
  },
  {
    "version": "2.16.11",
    "releasedAt": "2026-09-14T17:24:50.830Z",
    "summary": "- Import now shows the Robinhood Callback URL box at the top whenever the account is disconnected, so you can paste after Allow even if a snapshot is already on the page.\n- Robinhood authorize links are no longer reused past ~8 minutes, which was sending retries to an expired Robinhood consent URL.\n- A cooldown after a failed Robinhood complete no longer extends itself when you retry too soon."
  },
  {
    "version": "2.16.10",
    "releasedAt": "2026-09-14T16:36:11.806Z",
    "summary": "Robinhood auto-import no longer retries an already-booked option fill when Robinhood’s execution date is a few days before the ledger date\nAuto-import matches new fills against the own ledger so a StockForge rejection cannot loop forever"
  },
  {
    "version": "2.16.9",
    "releasedAt": "2026-09-14T16:06:26.732Z",
    "summary": "- Mobile Open in Robinhood opens the Robinhood app again (`/stocks/` and applink), instead of the website."
  },
  {
    "version": "2.16.8",
    "releasedAt": "2026-09-14T01:14:36.531Z",
    "summary": "- Terminal: Puts and Calls keep the ticker column inside the pane instead of hanging off the left edge."
  },
  {
    "version": "2.16.7",
    "releasedAt": "2026-09-13T22:03:25.339Z",
    "summary": "- Terminal: Open in Legend from Puts/Calls now tries to set the options chain to Sell Put or Sell Call."
  },
  {
    "version": "2.16.6",
    "releasedAt": "2026-09-13T21:58:49.900Z",
    "summary": "- Terminal: the row ⋮ menu stays open on click instead of flashing closed."
  },
  {
    "version": "2.16.5",
    "releasedAt": "2026-09-13T21:55:56.705Z",
    "summary": "Fix the Mac terminal ⋮ column so it sits in the last column instead of floating over Shares."
  },
  {
    "version": "2.16.4",
    "releasedAt": "2026-09-13T21:55:13.005Z",
    "summary": "Fix the Mac terminal ⋮ column so it sits in the last column instead of floating over Shares."
  },
  {
    "version": "2.16.3",
    "releasedAt": "2026-09-13T21:49:23.251Z",
    "summary": "Open in Legend from a row ⋮ menu in the Mac terminal opens the tab’s Legend widgets in separate windows (Puts/Calls: chart + chain; Options: chart + chain + positions; Stocks: chart + positions). In the browser it still opens Legend as one page."
  },
  {
    "version": "2.16.2",
    "releasedAt": "2026-09-13T21:47:42.831Z",
    "summary": "Row ⋮ menus stay pinned to the right of Puts, Calls, Options, Stocks, and History tables so they stay visible in the Mac terminal."
  },
  {
    "version": "2.16.1",
    "releasedAt": "2026-09-13T21:43:31.410Z",
    "summary": "Rename the row action from Open on Robinhood to Open in Robinhood, matching Open in Legend."
  },
  {
    "version": "2.16.0",
    "releasedAt": "2026-09-13T21:38:03.008Z",
    "summary": "Open in Legend on Puts, Calls, Options, Stocks, and History rows opens the matching Legend widgets (chart, chain, and/or positions) for that action.\nThose widget windows stack on the right of the Mac terminal and stay attached when you move or resize the shell."
  },
  {
    "version": "2.15.11",
    "releasedAt": "2026-09-13T21:22:47.027Z",
    "summary": "- Mac terminal: Legend widget menu items now show only that widget on the first open, not the full board."
  },
  {
    "version": "2.15.10",
    "releasedAt": "2026-09-13T21:04:51.031Z",
    "summary": "- Mac terminal: Robinhood split panes now use Chromium zoom so the full home page (account, chart, options) fits the cell."
  },
  {
    "version": "2.15.9",
    "releasedAt": "2026-09-13T20:48:05.332Z",
    "summary": "- Mac terminal: Robinhood split panes keep the account on the left while scaling the full page into the cell."
  },
  {
    "version": "2.15.8",
    "releasedAt": "2026-09-13T20:37:05.332Z",
    "summary": "- Mac terminal: Robinhood split panes scale from the left so the account and chart stay in view."
  },
  {
    "version": "2.15.7",
    "releasedAt": "2026-09-13T20:31:24.842Z",
    "summary": "- Mac terminal: Robinhood split panes keep the account and chart pinned on the left while still scaling to the cell."
  },
  {
    "version": "2.15.6",
    "releasedAt": "2026-09-13T20:26:25.852Z",
    "summary": "- Mac terminal: Legend widget menu items open that widget alone, not the full board."
  },
  {
    "version": "2.15.5",
    "releasedAt": "2026-09-13T20:18:48.267Z",
    "summary": "- Mac terminal: Robinhood split panes scale the full desktop page into the cell instead of needing a very wide window."
  },
  {
    "version": "2.15.4",
    "releasedAt": "2026-09-13T19:46:07.011Z",
    "summary": "- Mac terminal: Robinhood split panes pin the account header in view without shrinking the page to a blank pane."
  },
  {
    "version": "2.15.3",
    "releasedAt": "2026-09-13T19:39:13.236Z",
    "summary": "- Mac terminal: Robinhood split panes stay left-aligned so the account header is not clipped off the left edge."
  },
  {
    "version": "2.15.2",
    "releasedAt": "2026-09-13T19:31:01.215Z",
    "summary": "- Mac terminal: Legend menu now opens as a native menu so it is not hidden under Robinhood panes, and unzooming a Robinhood pane keeps the left side in view."
  },
  {
    "version": "2.15.1",
    "releasedAt": "2026-09-13T19:20:02.900Z",
    "summary": "- Fix the Mac terminal launch crash from the new Legend menu (missing packed file)."
  },
  {
    "version": "2.15.0",
    "releasedAt": "2026-09-13T19:12:54.595Z",
    "summary": "- Mac terminal: Legend in the title bar is now a menu. Open Legend still pops out the full board; pick a widget to open it in its own layout window."
  },
  {
    "version": "2.14.24",
    "releasedAt": "2026-09-13T19:01:52.955Z",
    "summary": "- Mac terminal: Show in Robinhood now reuses the open Robinhood pane instead of tearing it down and reloading the whole site."
  },
  {
    "version": "2.14.23",
    "releasedAt": "2026-09-13T18:52:26.699Z",
    "summary": "Robinhood split panes lay out at desktop width, scale to the tab, and stay left-aligned so both stacked panes show the full site."
  },
  {
    "version": "2.14.22",
    "releasedAt": "2026-09-13T18:44:06.017Z",
    "summary": "Robinhood split panes now lay out at desktop width and scale to the tab, so both stacked panes show the full site."
  },
  {
    "version": "2.14.21",
    "releasedAt": "2026-09-13T18:36:11.675Z",
    "summary": "Undo the Robinhood auto-shrink so split panes fill the tab again at normal size."
  },
  {
    "version": "2.14.20",
    "releasedAt": "2026-09-13T18:30:09.602Z",
    "summary": "Robinhood in a shorter or narrower split pane now scales to stay inside the frame instead of running off the left edge."
  },
  {
    "version": "2.14.19",
    "releasedAt": "2026-09-13T18:23:38.691Z",
    "summary": "Legend’s active border now draws on all four sides, including across the title bar."
  },
  {
    "version": "2.14.18",
    "releasedAt": "2026-09-13T18:17:43.699Z",
    "summary": "Legend’s title-bar button now has a clear up-right arrow showing it opens in its own window."
  },
  {
    "version": "2.14.17",
    "releasedAt": "2026-09-13T18:11:22.122Z",
    "summary": "Legend’s title-bar button now shows a pop-out arrow so it is obvious it opens in its own window."
  },
  {
    "version": "2.14.16",
    "releasedAt": "2026-09-13T18:03:50.559Z",
    "summary": "Fix a crash on launch after the last Robinhood zoom change."
  },
  {
    "version": "2.14.15",
    "releasedAt": "2026-09-13T17:59:50.478Z",
    "summary": "macOS no longer asks to reopen windows after an install or a hard quit."
  },
  {
    "version": "2.14.14",
    "releasedAt": "2026-09-13T17:53:33.419Z",
    "summary": "Robinhood split panes now scale the site to the pane instead of drawing past the edges."
  },
  {
    "version": "2.14.13",
    "releasedAt": "2026-09-13T17:46:13.758Z",
    "summary": "Two panes of the same app (for example two Robinhood splits) now zoom independently."
  },
  {
    "version": "2.14.12",
    "releasedAt": "2026-09-13T17:42:31.108Z",
    "summary": "Focusing Legend now clears every app button in the main window title bar."
  },
  {
    "version": "2.14.11",
    "releasedAt": "2026-09-13T17:38:27.034Z",
    "summary": "Title-bar StockForge+ wordmark now lines up vertically with the app buttons."
  },
  {
    "version": "2.14.10",
    "releasedAt": "2026-09-13T17:33:57.809Z",
    "summary": "Legend now has a full-width title bar you can drag, like the main terminal window."
  },
  {
    "version": "2.14.9",
    "releasedAt": "2026-09-13T17:25:17.926Z",
    "summary": "Zooming Legend no longer changes zoom in the main grid panes."
  },
  {
    "version": "2.14.8",
    "releasedAt": "2026-09-13T17:18:39.906Z",
    "summary": "Legend window now zooms with Cmd+/−/0 and pinch when it is focused.\nFocused Legend shows the same active blue border as a selected grid pane."
  },
  {
    "version": "2.14.7",
    "releasedAt": "2026-09-13T17:12:21.490Z",
    "summary": "Remove the empty Type column on Options — put/call is already on the ticker badge."
  },
  {
    "version": "2.14.6",
    "releasedAt": "2026-09-13T17:08:08.839Z",
    "summary": "Fix Legend getting stuck on its loading spinner.\nTitle bar: larger StockForge+ wordmark with orange +, white “terminal”, aligned with the buttons."
  },
  {
    "version": "2.14.5",
    "releasedAt": "2026-09-13T17:02:48.386Z",
    "summary": "Clicking a pane header now activates that window and focuses its contents."
  },
  {
    "version": "2.14.4",
    "releasedAt": "2026-09-13T16:57:37.126Z",
    "summary": "Title-bar app buttons now follow the focused pane or Legend window.\nApp buttons sit to the right of the title, with a gap before the layout icons."
  },
  {
    "version": "2.14.3",
    "releasedAt": "2026-09-13T16:39:27.982Z",
    "summary": "- Mac terminal: pane apps are title-bar buttons; Legend is spaced apart and opens in its own window."
  },
  {
    "version": "2.14.2",
    "releasedAt": "2026-09-13T16:35:14.681Z",
    "summary": "- Mac terminal: brand-colored title aligned with the layout buttons; Legend top tabs are clickable again."
  },
  {
    "version": "2.14.1",
    "releasedAt": "2026-09-13T16:30:33.172Z",
    "summary": "- Mac terminal: brighter selected layout icons and a gold pin control in the title bar."
  },
  {
    "version": "2.14.0",
    "releasedAt": "2026-09-13T16:25:33.569Z",
    "summary": "- Mac terminal: new layout with one tall pane on the left and two stacked on the right.\n- Layout switcher is now icons on the right of the title bar, with Pin at the far right."
  },
  {
    "version": "2.13.17",
    "releasedAt": "2026-09-13T16:18:30.633Z",
    "summary": "- Mac terminal: ignore leftover Chromium zoom on the grid chrome so panes stay aligned on machines that were used during earlier zoom tests."
  },
  {
    "version": "2.13.16",
    "releasedAt": "2026-09-13T16:09:30.856Z",
    "summary": "- Mac terminal: Cmd+/- and pinch zoom now scale the focused pane (StockForge+ or Robinhood), not the grid chrome."
  },
  {
    "version": "2.13.15",
    "releasedAt": "2026-09-13T16:05:35.420Z",
    "summary": "- Mac terminal: StockForge+ in a grid pane no longer draws the standalone-window blue frame or traffic-light inset, so it lines up with Robinhood on launch."
  },
  {
    "version": "2.13.14",
    "releasedAt": "2026-09-13T15:52:07.538Z",
    "summary": "- Mac terminal: Robinhood links and sign-in now stay inside grid panes instead of opening floating windows.\n- Passkey sign-in from a Robinhood pane opens Chrome and syncs the session back into the pane automatically."
  },
  {
    "version": "2.13.13",
    "releasedAt": "2026-09-13T15:45:38.958Z",
    "summary": "- Fix Mac app download on the website serving the old Sep 11 (1.0.0) build instead of the current release."
  },
  {
    "version": "2.13.12",
    "releasedAt": "2026-09-13T00:05:29.696Z",
    "summary": "- Complete rollback of Mac terminal shell to commit 4053069 (pre–floating-layout grid only).\n- Reset saved grid layout to single-pane defaults on install."
  },
  {
    "version": "2.13.11",
    "releasedAt": "2026-09-12T22:44:21.812Z",
    "summary": "- Roll back Mac terminal to the pre–floating-layout grid shell (1.0.28 codebase): tiled panes only, Legend in its own window."
  },
  {
    "version": "2.13.10",
    "releasedAt": "2026-09-12T22:38:48.329Z",
    "summary": "- Fix grid pane embed positioning — shell reports pane bounds directly so Robinhood/StockForge+ load inside each cell.\n- Show shell version (v…) in the toolbar so you can confirm which build is running."
  },
  {
    "version": "2.13.9",
    "releasedAt": "2026-09-12T22:29:34.571Z",
    "summary": "- Roll back Flexible layout mode — Mac terminal is fixed grid only again; Legend still opens in its own window."
  },
  {
    "version": "2.13.8",
    "releasedAt": "2026-09-12T22:20:28.080Z",
    "summary": "- Fix Robinhood spawning a floating window on startup instead of embedding in Fixed grid panes."
  },
  {
    "version": "2.13.7",
    "releasedAt": "2026-09-12T22:09:04.099Z",
    "summary": "- Fix Fixed grid Robinhood opening as a floating window on top of pane containers — RH now stays embedded in each grid cell."
  },
  {
    "version": "2.13.6",
    "releasedAt": "2026-09-12T22:04:37.716Z",
    "summary": "- Fix Fixed grid panes staying empty after Flexible mode or mode switches — BrowserViews now restore into each cell body."
  },
  {
    "version": "2.13.5",
    "releasedAt": "2026-09-12T21:58:23.075Z",
    "summary": "- Fix Fixed grid panes not opening when picking an app from the cell dropdown."
  },
  {
    "version": "2.13.4",
    "releasedAt": "2026-09-12T21:53:18.261Z",
    "summary": "- Fix Fixed grid panes misaligning after window zoom or maximize; Cmd+/- zoom applies per pane."
  },
  {
    "version": "2.13.3",
    "releasedAt": "2026-09-12T21:46:57.871Z",
    "summary": "- Fix Mac terminal crash on launch after copying to Applications (preserve code signature).\n- Fix Flexible mode re-opening all windows on every UI refresh."
  },
  {
    "version": "2.13.2",
    "releasedAt": "2026-09-12T21:43:09.963Z",
    "summary": "- Fix Flexible mode add-window buttons — remove grid BrowserViews that were blocking clicks."
  },
  {
    "version": "2.13.1",
    "releasedAt": "2026-09-12T21:38:30.843Z",
    "summary": "- Fix Mac terminal startup crash — include flexible layout module in the packaged app."
  },
  {
    "version": "2.13.0",
    "releasedAt": "2026-09-12T20:38:24.003Z",
    "summary": "- Mac terminal: Fixed/Flexible layout switch — grid tiles or freely sized floating windows.\n- Flexible mode remembers window positions; first switch from Fixed migrates open panes."
  },
  {
    "version": "2.12.8",
    "releasedAt": "2026-09-12T20:28:15.367Z",
    "summary": "- Mac grid pane picker is narrower; options use each app’s brand color.\n- Renamed StockForge site pane to Original Stock Forge."
  },
  {
    "version": "2.12.7",
    "releasedAt": "2026-09-12T20:19:35.850Z",
    "summary": "- Mac shell renamed to StockForgePlus terminal (header: StockForge+ terminal)."
  },
  {
    "version": "2.12.6",
    "releasedAt": "2026-09-12T20:17:07.053Z",
    "summary": "- Mac grid: new pane type StockForge site (thestockforge.com dashboard) in the cell selector."
  },
  {
    "version": "2.12.5",
    "releasedAt": "2026-09-12T20:14:41.154Z",
    "summary": "- Mac shell: Pin lives only in the title bar (removed from StockForge+ tab strip and Settings)."
  },
  {
    "version": "2.12.4",
    "releasedAt": "2026-09-12T20:12:14.036Z",
    "summary": "- Mac shell: larger window drag targets (title bar, Legend/Robinhood top strip, pane headers).\n- Mac grid: keep embedded panes from covering the draggable title bar."
  },
  {
    "version": "2.12.3",
    "releasedAt": "2026-09-12T20:09:04.399Z",
    "summary": "- Mac Legend window opens cascaded on top of the StockForge+ window so both are easy to spot."
  },
  {
    "version": "2.12.2",
    "releasedAt": "2026-09-12T20:03:37.367Z",
    "summary": "- Mac grid: Legend opens in a dedicated Robinhood Legend window (not embedded in the grid).\n- Mac grid: fix Robinhood pane sizing on startup and in 2×2 layouts."
  },
  {
    "version": "2.12.1",
    "releasedAt": "2026-09-12T19:57:18.262Z",
    "summary": "- Mac grid: Legend pane loads robinhood.com/legend (legend.robinhood.com fails TLS in Electron)."
  },
  {
    "version": "2.12.0",
    "releasedAt": "2026-09-12T19:53:45.958Z",
    "summary": "- Mac grid shell: refresh button on each pane header reloads that cell.\n- Mac 2×2 grid: left and right columns resize row heights independently."
  },
  {
    "version": "2.11.2",
    "releasedAt": "2026-09-12T18:12:22.538Z",
    "summary": "- Fix crash when opening Robinhood or Legend in a grid cell (JavaScript error on load)."
  },
  {
    "version": "2.11.1",
    "releasedAt": "2026-09-12T03:43:18.428Z",
    "summary": "- Drag the dividers in the Mac grid to resize StockForge+, Robinhood, and Legend panes."
  },
  {
    "version": "2.11.0",
    "releasedAt": "2026-09-11T23:40:47.064Z",
    "summary": "- Mac app window is now a grid: 1, side-by-side, stacked, or 2×2.\n- Each cell can be StockForge+, Robinhood, or Robinhood Legend. Show on Robinhood uses a Robinhood cell when one is open."
  },
  {
    "version": "2.10.12",
    "releasedAt": "2026-09-11T23:30:15.756Z",
    "summary": "- Restore the dark blue border on Mac shell windows (main app and Robinhood)."
  },
  {
    "version": "2.10.11",
    "releasedAt": "2026-09-11T23:27:19.798Z",
    "summary": "- The Mac Robinhood window can be dragged again (the hidden title bar had no grab area)."
  },
  {
    "version": "2.10.10",
    "releasedAt": "2026-09-11T23:23:08.559Z",
    "summary": "- Show on Robinhood opens a StockForge+ window again. Sign in there with your password (passkeys still do not finish in that window)."
  },
  {
    "version": "2.10.9",
    "releasedAt": "2026-09-11T23:09:56.277Z",
    "summary": "- Show on Robinhood and Log in with passkeys now stay in Chrome, where you are already signed in, instead of leaving a StockForge+ login window waiting for a session it cannot copy."
  },
  {
    "version": "2.10.8",
    "releasedAt": "2026-09-11T22:52:48.684Z",
    "summary": "- Log in with passkeys in the Mac Robinhood window now opens Chrome, where that passkey already works."
  },
  {
    "version": "2.10.7",
    "releasedAt": "2026-09-11T22:41:07.606Z",
    "summary": "- Show on Robinhood opens a StockForge+ window again (the separate helper crashed and hid behind the pinned app).\n- Open Chrome is on that window if you need the signed-in Chrome session."
  },
  {
    "version": "2.10.6",
    "releasedAt": "2026-09-11T22:30:00.718Z",
    "summary": "- Robinhood passkey sheet can now appear in the Mac window (it was aborting as “cancelled”).\n- Login shows Open Chrome for the passkey that already works in Chrome."
  },
  {
    "version": "2.10.5",
    "releasedAt": "2026-09-11T22:18:54.731Z",
    "summary": "- Mac Robinhood window now uses Safari WebKit so passkeys can finish in-app (Chrome login cannot be copied).\n- Sign in once in that window; it stays signed in after that."
  },
  {
    "version": "2.10.4",
    "releasedAt": "2026-09-11T21:39:50.063Z",
    "summary": "- Mac app window border uses the same soft blue glow as the StockForge+ wordmark."
  },
  {
    "version": "2.10.3",
    "releasedAt": "2026-09-11T21:37:27.912Z",
    "summary": "- Mac app window border matches the StockForge+ logo blue."
  },
  {
    "version": "2.10.2",
    "releasedAt": "2026-09-11T21:31:02.009Z",
    "summary": "- Mac app pin control is on the right of the top bar."
  },
  {
    "version": "2.10.1",
    "releasedAt": "2026-09-11T21:28:55.260Z",
    "summary": "- Mac app window has a bright blue border so it is easier to spot against other windows."
  },
  {
    "version": "2.10.0",
    "releasedAt": "2026-09-11T21:26:18.437Z",
    "summary": "- Mac Open on Robinhood now opens a second StockForge+ window. Passkeys still complete in Chrome, then that login is copied back into the app."
  },
  {
    "version": "2.9.8",
    "releasedAt": "2026-09-11T21:17:59.056Z",
    "summary": "- Mac Open on Robinhood reuses your Chrome Robinhood tab, or opens a new Chrome window instead of stacking tabs."
  },
  {
    "version": "2.9.7",
    "releasedAt": "2026-09-11T21:14:02.228Z",
    "summary": "- Mac app opens Robinhood in Chrome so passkeys / Touch ID can complete (they hang inside the shell window)."
  },
  {
    "version": "2.9.6",
    "releasedAt": "2026-09-11T21:04:02.943Z",
    "summary": "- Mac app uses a dark inset title bar so the StockForge+ header is the toolbar."
  },
  {
    "version": "2.9.5",
    "releasedAt": "2026-09-11T20:58:27.542Z",
    "summary": "- Mac app tab bar has a pin button; when on, this window and Robinhood popups stay above other apps."
  },
  {
    "version": "2.9.4",
    "releasedAt": "2026-09-11T20:50:46.277Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.9.3",
    "releasedAt": "2026-09-11T20:49:39.429Z",
    "summary": "- Settings Mac app notes now explain the macOS “damaged” warning and the xattr fix for an unsigned download."
  },
  {
    "version": "2.9.2",
    "releasedAt": "2026-09-11T20:44:03.892Z",
    "summary": "- Settings Mac download is a real file link so the .dmg starts downloading."
  },
  {
    "version": "2.9.1",
    "releasedAt": "2026-09-11T20:42:12.243Z",
    "summary": "- Settings Mac app download now starts the .dmg instead of a dead link."
  },
  {
    "version": "2.9.0",
    "releasedAt": "2026-09-11T20:37:11.666Z",
    "summary": "- Settings now has a Mac app download. The optional desktop shell loads this same site, can stay on top, and updates itself when a new shell is published."
  },
  {
    "version": "2.8.45",
    "releasedAt": "2026-09-11T18:43:40.093Z",
    "summary": "- Settings now has a Robinhood section: Show on Robinhood (tab vs popup), snapshot refresh, and account aliases."
  },
  {
    "version": "2.8.44",
    "releasedAt": "2026-09-11T18:34:06.327Z",
    "summary": "- Open on Robinhood warms the Robinhood connection before the click and skips an extra stock-page redirect."
  },
  {
    "version": "2.8.43",
    "releasedAt": "2026-09-11T18:25:46.072Z",
    "summary": "- Open on Robinhood now uses a small resizable popup window and keeps sending later clicks there."
  },
  {
    "version": "2.8.42",
    "releasedAt": "2026-09-11T18:18:11.992Z",
    "summary": "- Tax Other income totals cards under the table are 30% wider."
  },
  {
    "version": "2.8.41",
    "releasedAt": "2026-09-11T18:06:44.925Z",
    "summary": "- Open on Robinhood reuses the existing Robinhood tab (including a Chrome split-view pane we opened) and navigates it instead of spawning a new one each time."
  },
  {
    "version": "2.8.40",
    "releasedAt": "2026-09-11T18:04:42.428Z",
    "summary": "- Open on Robinhood reuses the existing Robinhood tab (including a Chrome split-view pane we opened) and navigates it instead of spawning a new one each time."
  },
  {
    "version": "2.8.39",
    "releasedAt": "2026-09-11T18:02:37.875Z",
    "summary": "- Open on Robinhood reuses the existing Robinhood tab (including a Chrome split-view pane we opened) instead of spawning a new one each time."
  },
  {
    "version": "2.8.38",
    "releasedAt": "2026-09-11T17:53:16.546Z",
    "summary": "- Early-BTC green dot no longer treats a sub-1% option P/L as ~100% captured (e.g. MU opened today)."
  },
  {
    "version": "2.8.37",
    "releasedAt": "2026-09-11T15:08:42.004Z",
    "summary": "- Tax Trading, Other income, and FIFO totals cards are narrower with larger amounts."
  },
  {
    "version": "2.8.36",
    "releasedAt": "2026-09-11T15:05:32.703Z",
    "summary": "- Tax Trading, Other income, and FIFO totals cards are narrower with larger amounts."
  },
  {
    "version": "2.8.35",
    "releasedAt": "2026-09-11T02:19:48.217Z",
    "summary": "- Tax Other income totals are now a 2×2: Trading and Other income on top, FIFO and Combined Total income below."
  },
  {
    "version": "2.8.34",
    "releasedAt": "2026-09-11T02:18:26.211Z",
    "summary": "- Tax Other income totals are now a 2×2: Trading and Other income on top, FIFO and Combined Total income below."
  },
  {
    "version": "2.8.33",
    "releasedAt": "2026-09-10T20:19:39.612Z",
    "summary": "- Tax Other income totals now put Trading, FIFO, and Other income in one row, with a W-2-style Total income card underneath."
  },
  {
    "version": "2.8.32",
    "releasedAt": "2026-09-10T20:18:40.622Z",
    "summary": "- Tax Other income totals now put Trading, FIFO, and Other income in one row, with a W-2-style Total income card underneath."
  },
  {
    "version": "2.8.31",
    "releasedAt": "2026-09-10T20:15:29.256Z",
    "summary": "- Tax Trading and FIFO cards now show the year total first, then Fact/Forecast underneath."
  },
  {
    "version": "2.8.30",
    "releasedAt": "2026-09-10T19:26:26.610Z",
    "summary": "- Tax Other income Fact/Forecast rows now put the badge on the left and the amount on the right, matching W-2 totals."
  },
  {
    "version": "2.8.29",
    "releasedAt": "2026-09-10T18:16:05.627Z",
    "summary": "- Tax Other income Fact/Forecast amounts sit next to the badges, matching the W-2 totals cards."
  },
  {
    "version": "2.8.28",
    "releasedAt": "2026-09-10T18:12:53.046Z",
    "summary": "- Tax Other income and Taxes now use the same Fact/Forecast Gross | Tax layout as the W-2 totals cards."
  },
  {
    "version": "2.8.27",
    "releasedAt": "2026-09-10T18:08:07.182Z",
    "summary": "- Tax Other income summary cards are narrower so Fact/Forecast amounts sit closer together."
  },
  {
    "version": "2.8.26",
    "releasedAt": "2026-09-10T17:59:24.128Z",
    "summary": "- Cards, filter bars, and tables on every tab keep their dark fill and lift with the same drop shadow as Tax."
  },
  {
    "version": "2.8.25",
    "releasedAt": "2026-09-10T17:47:29.394Z",
    "summary": "- Tax cards keep the original dark fill and stand out with a deeper drop shadow instead of a washed-out color."
  },
  {
    "version": "2.8.24",
    "releasedAt": "2026-09-10T17:35:52.217Z",
    "summary": "- Tax cards stay dark, with a slightly lighter fill and clearer border so they stand out from the page."
  },
  {
    "version": "2.8.23",
    "releasedAt": "2026-09-10T17:34:40.264Z",
    "summary": "- Tax cards use a slightly lighter fill and stronger border so they stand out from the page."
  },
  {
    "version": "2.8.22",
    "releasedAt": "2026-09-10T17:33:00.010Z",
    "summary": "- Tax Total income card is half the row width, aligned with Trading and FIFO."
  },
  {
    "version": "2.8.21",
    "releasedAt": "2026-09-10T17:32:14.598Z",
    "summary": "- Tax Total income card is half as wide so it lines up with the Trading and FIFO totals."
  },
  {
    "version": "2.8.20",
    "releasedAt": "2026-09-10T17:29:38.123Z",
    "summary": "- Tax Other income cards sit under the Other income table, with a smaller Total income figure plus Fact/Forecast when the year is mixed.\n- Trading and FIFO totals cards are wider so full dollar amounts stay visible."
  },
  {
    "version": "2.8.19",
    "releasedAt": "2026-09-10T17:19:17.118Z",
    "summary": "- Tax Other income table: left-align row values to match the headers."
  },
  {
    "version": "2.8.18",
    "releasedAt": "2026-09-10T17:16:20.395Z",
    "summary": "- Tax Other income table: left-align column headers."
  },
  {
    "version": "2.8.17",
    "releasedAt": "2026-09-10T17:01:51.762Z",
    "summary": "- Tax Other income table: wider Date and Income columns, left-aligned notes, and Edit/Delete buttons that match the table."
  },
  {
    "version": "2.8.16",
    "releasedAt": "2026-09-10T16:55:43.937Z",
    "summary": "- Call assignment P/L can go negative when same-day put shares raise avg cost above the call strike."
  },
  {
    "version": "2.8.15",
    "releasedAt": "2026-09-10T16:47:05.507Z",
    "summary": "- Restore pre-August Robinhood margin costs in History from the own-capital cash ledger (snapshot history only starts in August).\n- Keep August margin on snapshot accruals; current-month margin stays a forecast."
  },
  {
    "version": "2.8.14",
    "releasedAt": "2026-09-10T16:36:49.724Z",
    "summary": "- Performance Graph plots margin cost and BTC cost as positive dollar series so the left axis stays at $0 and up"
  },
  {
    "version": "2.8.13",
    "releasedAt": "2026-09-10T16:36:02.073Z",
    "summary": "- Performance Graph plots margin cost as a positive dollar series so the left axis stays above zero"
  },
  {
    "version": "2.8.12",
    "releasedAt": "2026-09-10T16:30:18.282Z",
    "summary": "- Performance Graph: skip empty dotted stubs on series that have no forecast values"
  },
  {
    "version": "2.8.11",
    "releasedAt": "2026-09-10T16:29:22.674Z",
    "summary": "- Performance Graph plots future months as forecast (dotted): target income, planned EOM, ROC, and predicted margin\n- Actual months stay solid; a Forecast band marks the handoff"
  },
  {
    "version": "2.8.10",
    "releasedAt": "2026-09-10T16:27:54.749Z",
    "summary": "- Performance Graph: future months show forecast income, own capital, ROC, and margin as dotted lines with a Forecast band\n- Actual months stay solid; forecast dots are hollow"
  },
  {
    "version": "2.8.9",
    "releasedAt": "2026-09-10T16:20:53.943Z",
    "summary": "- Analytics chart section title is now Performance Graph"
  },
  {
    "version": "2.8.8",
    "releasedAt": "2026-09-10T15:57:56.024Z",
    "summary": "- Income-by-month premiums line is dashed and a lighter green"
  },
  {
    "version": "2.8.7",
    "releasedAt": "2026-09-10T15:20:33.367Z",
    "summary": "- Income-by-month ROC % axis is fixed at 0–25%"
  },
  {
    "version": "2.8.6",
    "releasedAt": "2026-09-10T15:18:34.351Z",
    "summary": "- Income-by-month: own-capital EOM stays on its own scale (empty forecast months no longer pin the line to $0)\n- Income line is a visible deep green; margin cost red; BTC cost yellow"
  },
  {
    "version": "2.8.5",
    "releasedAt": "2026-09-10T15:16:58.442Z",
    "summary": "- Income-by-month chart: total own capital EOM is a bold orange line (own scale so monthly income stays readable)\n- Income is deep green and bold; margin cost is red; BTC cost is yellow"
  },
  {
    "version": "2.8.4",
    "releasedAt": "2026-09-10T15:15:20.782Z",
    "summary": "- Analytics income graph: own capital EOM as a bold orange line; income deep green; BTC yellow; margin red."
  },
  {
    "version": "2.8.3",
    "releasedAt": "2026-09-10T15:13:10.331Z",
    "summary": "- Analytics income graph now plots return on own capital % on a second axis."
  },
  {
    "version": "2.8.2",
    "releasedAt": "2026-09-10T14:57:50.832Z",
    "summary": "- Analytics: Stock Positions | Shares card is half as wide."
  },
  {
    "version": "2.8.1",
    "releasedAt": "2026-09-10T14:56:24.800Z",
    "summary": "- Total Income card: “Tot. margin cost” stays on one line."
  },
  {
    "version": "2.8.0",
    "releasedAt": "2026-09-10T14:50:32.975Z",
    "summary": "- Analytics Total Performance now has a collapsible monthly graph for premiums, call assignments, BTC cost, margin cost, and income."
  },
  {
    "version": "2.7.19",
    "releasedAt": "2026-09-10T14:39:19.252Z",
    "summary": "- Analytics Total Performance: stock cards align with the row above, Positions | Shares stays on one line, and dollar/share numbers are a bit smaller."
  },
  {
    "version": "2.7.18",
    "releasedAt": "2026-09-10T14:33:40.657Z",
    "summary": "- Analytics Income cards no longer show Est. tax paid. That figure stays on Tax Due."
  },
  {
    "version": "2.7.17",
    "releasedAt": "2026-09-10T00:42:19.874Z",
    "summary": "- Analytics Reset filters now clears the ticker (and type) filter, not just year chips."
  },
  {
    "version": "2.7.16",
    "releasedAt": "2026-09-10T00:38:47.210Z",
    "summary": "- Reset filters now uses the same steel-blue as Analytics-SF on every tab."
  },
  {
    "version": "2.7.15",
    "releasedAt": "2026-09-09T16:29:19.515Z",
    "summary": "- When no advisor is on, Puts, Calls, and Options hide the advised count as well as the Run button."
  },
  {
    "version": "2.7.14",
    "releasedAt": "2026-09-09T16:22:27.824Z",
    "summary": "- Hide Run agent advice on Puts, Calls, and Options when no advisor is on. The advised count stays visible."
  },
  {
    "version": "2.7.13",
    "releasedAt": "2026-09-09T16:03:58.571Z",
    "summary": "- Web Stocks now refreshes prices in place, same as Options, instead of remounting the table."
  },
  {
    "version": "2.7.12",
    "releasedAt": "2026-09-09T15:46:18.679Z",
    "summary": "- Dropped the “after est. tax paid” caption on Income cards. The Est. tax paid line still explains the deduction."
  },
  {
    "version": "2.7.11",
    "releasedAt": "2026-09-09T15:36:06.588Z",
    "summary": "- Mobile Focus menu item now uses the same target icon as web."
  },
  {
    "version": "2.7.10",
    "releasedAt": "2026-09-09T15:28:32.740Z",
    "summary": "- Stocks row menu now has Focus and Open on Robinhood, same as Options / Puts / Calls.\n- Focus is bright cyan in every tab menu so it stands out next to Robinhood green."
  },
  {
    "version": "2.7.9",
    "releasedAt": "2026-09-09T15:20:52.945Z",
    "summary": "- Open on Robinhood now sits directly under Focus on Puts, Calls, and Options menus.\n- That item uses Robinhood green so it is easy to pick out."
  },
  {
    "version": "2.7.8",
    "releasedAt": "2026-09-09T15:18:25.188Z",
    "summary": "- Mobile Options ticker menu now opens the row you tapped, even when the table is sorted."
  },
  {
    "version": "2.7.7",
    "releasedAt": "2026-09-09T01:51:25.875Z",
    "summary": "- Mobile Options column order now survives reload (Risk / opty was being dropped on the server).\n- Focus+ open-column order is stored the same way, so reordered columns stay put."
  },
  {
    "version": "2.7.6",
    "releasedAt": "2026-09-09T01:43:55.924Z",
    "summary": "- Other income list is now the main table, with fonts matching Trading income.\n- Add and edit records in a modal; delete remains on each row."
  },
  {
    "version": "2.7.5",
    "releasedAt": "2026-09-09T01:32:08.058Z",
    "summary": "- Tax: keep Trading and Other income tables on top, move totals underneath, and add a Total income summary"
  },
  {
    "version": "2.7.4",
    "releasedAt": "2026-09-09T01:22:50.854Z",
    "summary": "- Tax: keep Other income and Tax contributed cards side by side under the other-income table"
  },
  {
    "version": "2.7.3",
    "releasedAt": "2026-09-09T01:21:37.985Z",
    "summary": "- Tax: compact Other Income totals, put other/tax cards side by side, and widen the other-income table"
  },
  {
    "version": "2.7.2",
    "releasedAt": "2026-09-08T19:41:45.466Z",
    "summary": "- Tax: place Other income & tax beside Trading income instead of below it"
  },
  {
    "version": "2.7.1",
    "releasedAt": "2026-09-08T19:23:14.380Z",
    "summary": "- Tax: keep the Other income Add button visible instead of clipping it off the card"
  },
  {
    "version": "2.7.0",
    "releasedAt": "2026-09-08T19:14:47.120Z",
    "summary": "- Tax: add a dated Other income list (amount, tax contributed, who generated, note) separate from trading\n- Other income and tax contributed now flow into taxable income, tax paid, and safe-harbour totals"
  },
  {
    "version": "2.6.6",
    "releasedAt": "2026-09-08T02:23:17.942Z",
    "summary": "- Open on Robinhood for Puts is back to the contract page (the sell-ticket experiments did not change the app)."
  },
  {
    "version": "2.6.5",
    "releasedAt": "2026-09-08T02:21:34.724Z",
    "summary": "- Puts Open on Robinhood now encodes Size in the strategy code (experiment)."
  },
  {
    "version": "2.6.4",
    "releasedAt": "2026-09-08T02:17:55.014Z",
    "summary": "- Puts Open on Robinhood now sends is_leg=false (experiment)."
  },
  {
    "version": "2.6.3",
    "releasedAt": "2026-09-08T02:16:31.621Z",
    "summary": "- Puts Open on Robinhood now also sends contract Size as quantity (experiment)."
  },
  {
    "version": "2.6.2",
    "releasedAt": "2026-09-08T02:13:57.005Z",
    "summary": "- Open on Robinhood no longer shows the app version on the button."
  },
  {
    "version": "2.6.1",
    "releasedAt": "2026-09-08T02:10:49.705Z",
    "summary": "- Removed the internal Robinhood link test page."
  },
  {
    "version": "2.6.0",
    "releasedAt": "2026-09-08T02:08:28.030Z",
    "summary": "- Open on Robinhood now lands on the exact contract's page with Sell/Buy buttons, instead of the option chain guessing the side from your last trade.\n- Puts, Calls and Options all use the contract page; the chain is only a fallback when the contract cannot be resolved."
  },
  {
    "version": "2.5.5",
    "releasedAt": "2026-09-08T02:03:53.539Z",
    "summary": "- Robinhood link test page now builds one-leg strategy codes from the contract's instrument id."
  },
  {
    "version": "2.5.4",
    "releasedAt": "2026-09-08T01:34:35.090Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.5.3",
    "releasedAt": "2026-09-08T01:26:09.326Z",
    "summary": "- Robinhood link test page can now warm up the app on a neutral screen before delivering the chain link."
  },
  {
    "version": "2.5.2",
    "releasedAt": "2026-09-08T01:24:33.672Z",
    "summary": "- Robinhood link test page now logs each trial with its warm/cold mode and the observed outcome."
  },
  {
    "version": "2.5.1",
    "releasedAt": "2026-09-08T01:19:27.482Z",
    "summary": "- Reverted Open on Robinhood to the option chain: the order-form deep links landed on the Robinhood home screen."
  },
  {
    "version": "2.5.0",
    "releasedAt": "2026-09-08T01:16:19.048Z",
    "summary": "- Open on Robinhood now lands on an order ticket instead of the option chain: Puts/Calls open a new-position form and Options opens a close form.\n- Falls back to the option chain when the contract's instrument id is not resolved yet."
  },
  {
    "version": "2.4.53",
    "releasedAt": "2026-09-07T22:04:31.747Z",
    "summary": "- Robinhood link test page now probes the native-only `option_position_open` order-form route."
  },
  {
    "version": "2.4.52",
    "releasedAt": "2026-09-07T21:59:04.458Z",
    "summary": "- Added an internal Robinhood link test page at `/app/rhlab.html` for probing applink routes."
  },
  {
    "version": "2.4.51",
    "releasedAt": "2026-09-07T21:47:36.608Z",
    "summary": "- Mobile Puts/Calls open the option-chain applink with no side or strategy hints."
  },
  {
    "version": "2.4.50",
    "releasedAt": "2026-09-07T21:45:11.718Z",
    "summary": "- Mobile Puts/Calls send only the contract side on the option-chain applink; the strategy slug is dropped."
  },
  {
    "version": "2.4.49",
    "releasedAt": "2026-09-07T21:44:39.591Z",
    "summary": "- Mobile Puts/Calls send both the one-leg strategy slug and the contract side on the option-chain applink."
  },
  {
    "version": "2.4.48",
    "releasedAt": "2026-09-07T21:36:07.174Z",
    "summary": "- Mobile Puts/Calls pass the one-leg strategy slug on the option-chain applink (`type=short_put` / `type=short_call`)."
  },
  {
    "version": "2.4.47",
    "releasedAt": "2026-09-07T21:32:47.408Z",
    "summary": "- Mobile Puts/Calls leave the Strategy Builder intro and open the option-chain ticket again."
  },
  {
    "version": "2.4.46",
    "releasedAt": "2026-09-07T21:31:37.500Z",
    "summary": "- Mobile Puts/Calls retry the strategy-builder applink with `type=short_put` or `type=short_call`."
  },
  {
    "version": "2.4.45",
    "releasedAt": "2026-09-07T21:30:20.771Z",
    "summary": "- Mobile Puts/Calls leave the Strategy Builder intro splash and open the option-chain ticket again."
  },
  {
    "version": "2.4.44",
    "releasedAt": "2026-09-07T21:28:33.285Z",
    "summary": "- Mobile Puts/Calls open Robinhood’s one-leg strategy builder (`short_put` / `short_call`) instead of the raw option chain."
  },
  {
    "version": "2.4.43",
    "releasedAt": "2026-09-07T21:25:54.162Z",
    "summary": "- Mobile Puts now send `side=put` on the option-chain applink, matching Calls."
  },
  {
    "version": "2.4.42",
    "releasedAt": "2026-09-07T21:23:35.982Z",
    "summary": "- Mobile Calls leave the strategy builder and both Puts/Calls use the option-chain applink, with `type=put` or `type=call`."
  },
  {
    "version": "2.4.41",
    "releasedAt": "2026-09-07T21:21:18.356Z",
    "summary": "- Mobile Calls open Robinhood’s strategy builder (sell-call) and Puts stay on the option-chain applink so they no longer share the last ticket."
  },
  {
    "version": "2.4.40",
    "releasedAt": "2026-09-07T21:18:44.712Z",
    "summary": "- Mobile Open on Robinhood mints a new option-chain applink on every tap so Chrome does not reuse the last sell-call ticket."
  },
  {
    "version": "2.4.39",
    "releasedAt": "2026-09-07T21:15:42.121Z",
    "summary": "- Mobile option-chain applink drops `action=sell` (it forced sell-call) and separates Puts/Calls with `side` plus a distinct `source`."
  },
  {
    "version": "2.4.38",
    "releasedAt": "2026-09-07T21:14:06.388Z",
    "summary": "- Mobile Puts/Calls now send `side` and `action=sell` on the option-chain applink so Robinhood does not reuse the last buy/call ticket."
  },
  {
    "version": "2.4.37",
    "releasedAt": "2026-09-07T21:06:15.349Z",
    "summary": "- Mobile app shell is no longer cached, so Open on Robinhood picks up the current build instead of an old sell-call link."
  },
  {
    "version": "2.4.36",
    "releasedAt": "2026-09-07T20:59:58.330Z",
    "summary": "- Mobile Puts open the option-chain applink without `side` so Robinhood stays on sell-put (Calls still pass `side=call`)."
  },
  {
    "version": "2.4.35",
    "releasedAt": "2026-09-07T20:57:01.846Z",
    "summary": "- Mobile Puts wait for the option-chain applink with `side=put` instead of falling back to the sell-call strategy builder."
  },
  {
    "version": "2.4.34",
    "releasedAt": "2026-09-07T20:54:05.080Z",
    "summary": "- Mobile Options Open on Robinhood again opens the ticker in the app (the BTC chain link was an empty loader)."
  },
  {
    "version": "2.4.33",
    "releasedAt": "2026-09-07T20:53:37.791Z",
    "summary": "- Mobile Options Open on Robinhood now tries the option-chain applink with `side` and `action=buy` for BTC."
  },
  {
    "version": "2.4.32",
    "releasedAt": "2026-09-07T20:50:34.041Z",
    "summary": "- Mobile Options Open on Robinhood now tries the contract buy ticket (`option_position` + `side`) for BTC."
  },
  {
    "version": "2.4.31",
    "releasedAt": "2026-09-07T20:47:10.793Z",
    "summary": "- Mobile Puts/Calls Open on Robinhood now pass `side=put` or `side=call` on the option-chain applink."
  },
  {
    "version": "2.4.30",
    "releasedAt": "2026-09-07T20:38:21.817Z",
    "summary": "- Removed the hidden Robinhood applink experiment list from mobile."
  },
  {
    "version": "2.4.29",
    "releasedAt": "2026-09-07T19:57:48.092Z",
    "summary": "- Hidden Robinhood link experiments on mobile (`?rhx=1`) so we can tap alternate applink params."
  },
  {
    "version": "2.4.28",
    "releasedAt": "2026-09-07T19:00:53.397Z",
    "summary": "- Mobile Options Open on Robinhood now opens the ticker in the Robinhood app instead of the website home page."
  },
  {
    "version": "2.4.27",
    "releasedAt": "2026-09-07T18:34:04.242Z",
    "summary": "- Robinhood import now stores each option fill’s contract and chain IDs on the own ledger, and backfills them on the next import."
  },
  {
    "version": "2.4.26",
    "releasedAt": "2026-09-07T18:25:49.169Z",
    "summary": "- Mobile Calls Open on Robinhood now opens the ticker in the Robinhood app.\n- Mobile Options Open on Robinhood now opens Robinhood’s home page."
  },
  {
    "version": "2.4.25",
    "releasedAt": "2026-09-07T18:16:26.829Z",
    "summary": "- Mobile Open on Robinhood from Calls now opens the sell-call page. Open options still open the stock in the app."
  },
  {
    "version": "2.4.24",
    "releasedAt": "2026-09-07T18:12:57.812Z",
    "summary": "- Mobile Open on Robinhood for calls now opens the stock in the Robinhood app (the previous stock app-link was invalid and spun forever)."
  },
  {
    "version": "2.4.23",
    "releasedAt": "2026-09-07T18:11:59.126Z",
    "summary": "- Mobile Open on Robinhood for calls now opens that stock in the Robinhood app (the contract link was landing on buy-put)."
  },
  {
    "version": "2.4.22",
    "releasedAt": "2026-09-07T18:09:31.666Z",
    "summary": "- Mobile Open on Robinhood for open options now opens that contract’s page in the app, not the sell-put chain."
  },
  {
    "version": "2.4.21",
    "releasedAt": "2026-09-07T18:04:24.676Z",
    "summary": "- Mobile Open on Robinhood for Calls and open options now opens the Robinhood app, same as Puts."
  },
  {
    "version": "2.4.20",
    "releasedAt": "2026-09-07T18:02:35.601Z",
    "summary": "- Mobile Calls no longer shows On/Off, rubric band, or Profit% filters."
  },
  {
    "version": "2.4.19",
    "releasedAt": "2026-09-07T17:59:22.330Z",
    "summary": "- Mobile Open on Robinhood for Calls and open call contracts now opens the sell-call / contract page in the browser (the app has no sell-call deep link)."
  },
  {
    "version": "2.4.18",
    "releasedAt": "2026-09-07T17:57:44.371Z",
    "summary": "- Mobile Open on Robinhood for Calls and open call contracts now opens the sell-call / contract page instead of the put chain."
  },
  {
    "version": "2.4.17",
    "releasedAt": "2026-09-07T17:56:08.645Z",
    "summary": "- Mobile Focus from Options, Puts, and Calls now filters that ticker on the current tab, same as web."
  },
  {
    "version": "2.4.16",
    "releasedAt": "2026-09-07T17:48:47.805Z",
    "summary": "- Mobile Open on Robinhood from Calls now asks the app for the call / short-call side instead of defaulting to sell-put."
  },
  {
    "version": "2.4.15",
    "releasedAt": "2026-09-07T17:45:50.712Z",
    "summary": "- Mobile Open on Robinhood for open options now uses the option chain (same as Puts) instead of a broken position id."
  },
  {
    "version": "2.4.14",
    "releasedAt": "2026-09-07T17:38:09.389Z",
    "summary": "- Mobile Puts/Calls open the Robinhood app on the sell-put or sell-call chain; open options still open the held contract to BTC."
  },
  {
    "version": "2.4.13",
    "releasedAt": "2026-09-07T17:36:43.336Z",
    "summary": "- Mobile Open on Robinhood now uses Robinhood app links (`/u/…`) so iOS opens the app for sell-put, sell-call, and BTC."
  },
  {
    "version": "2.4.12",
    "releasedAt": "2026-09-07T17:33:04.104Z",
    "summary": "- Mobile Open on Robinhood now launches the Robinhood app (sell-put, sell-call, or BTC) instead of a browser tab."
  },
  {
    "version": "2.4.11",
    "releasedAt": "2026-09-07T17:26:58.168Z",
    "summary": "- Open on Robinhood from Puts/Calls lands on the sell-put or sell-call ticket.\n- Open options now open the contract’s buy-to-close page when the Robinhood instrument is known."
  },
  {
    "version": "2.4.10",
    "releasedAt": "2026-09-07T17:08:19.642Z",
    "summary": "- Open on Robinhood uses the named tab instead of a popup window."
  },
  {
    "version": "2.4.9",
    "releasedAt": "2026-09-07T17:00:33.382Z",
    "summary": "- Reuse the existing named Robinhood window (including split view) instead of opening another."
  },
  {
    "version": "2.4.8",
    "releasedAt": "2026-09-07T16:51:36.933Z",
    "summary": "- Reuse the last Robinhood window when opening a ticker from web."
  },
  {
    "version": "2.4.7",
    "releasedAt": "2026-09-07T16:34:45.544Z",
    "summary": "- Drop leftover category text on mobile Analytics cash lines."
  },
  {
    "version": "2.4.6",
    "releasedAt": "2026-09-07T16:32:31.060Z",
    "summary": "- Show Deposit/Withdraw amounts on mobile Analytics cash lines; P/L stays “—”."
  },
  {
    "version": "2.4.5",
    "releasedAt": "2026-09-07T16:25:56.128Z",
    "summary": "Shrink the collapsed Options and Stocks insight section titles on mobile."
  },
  {
    "version": "2.4.4",
    "releasedAt": "2026-09-07T16:17:12.970Z",
    "summary": "Timed quote refresh on mobile Puts, Calls, Stocks, and Focus now updates rows in place instead of showing the loading wheel."
  },
  {
    "version": "2.4.3",
    "releasedAt": "2026-09-07T16:10:13.423Z",
    "summary": "Keep Analytics P/L amounts inside their cards on mobile so day totals no longer run off the right edge."
  },
  {
    "version": "2.4.2",
    "releasedAt": "2026-09-07T16:01:36.599Z",
    "summary": "Mobile tab switches now show cached content immediately instead of waiting on a full reload.\nReturning to a tab you already opened keeps its last view, so Options ↔ Stocks feels as snappy as web."
  },
  {
    "version": "2.4.1",
    "releasedAt": "2026-09-07T15:53:52.404Z",
    "summary": "- Shorten the mobile Stocks diversification header to Share Diversification"
  },
  {
    "version": "2.4.0",
    "releasedAt": "2026-09-07T15:50:32.189Z",
    "summary": "- Mobile Stocks tab now has the same Performance and Diversification collapsible sections as web\n- Both sections start collapsed so the holdings table stays first"
  },
  {
    "version": "2.3.2",
    "releasedAt": "2026-09-07T15:47:19.214Z",
    "summary": "- Color the mobile Options Call Risk/Opty total red when negative"
  },
  {
    "version": "2.3.1",
    "releasedAt": "2026-09-07T15:46:12.472Z",
    "summary": "- Smaller Options Performance and Diversification headers when those sections are collapsed"
  },
  {
    "version": "2.3.0",
    "releasedAt": "2026-09-07T15:41:13.026Z",
    "summary": "- Mobile Options tab now has the same Performance and Diversification collapsible sections as web\n- Both sections start collapsed so the positions table stays first"
  },
  {
    "version": "2.2.5",
    "releasedAt": "2026-09-03T20:23:01.050Z",
    "summary": "- Options, Calls, and Puts row menus can open the ticker’s Robinhood options chain in a reusable nearby tab."
  },
  {
    "version": "2.2.4",
    "releasedAt": "2026-09-03T20:13:21.814Z",
    "summary": "- Analytics(L): cash rows never show a P/L amount (deposits, withdrawals, margin) — enforced at the cell renderer."
  },
  {
    "version": "2.2.3",
    "releasedAt": "2026-09-03T15:32:17.426Z",
    "summary": "- Analytics(L): cash rows (deposits, withdrawals, margin) no longer show a P/L amount in the day history table."
  },
  {
    "version": "2.2.2",
    "releasedAt": "2026-09-02T20:52:48.379Z",
    "summary": "Risky Calls: Max loss and Profit columns move after Avg cost; Avg cost subline shows available shares (not contracts)."
  },
  {
    "version": "2.2.1",
    "releasedAt": "2026-09-02T20:31:49.290Z",
    "summary": "Calls column picker: Strike and Expiry can be hidden and reordered (no longer fixed)."
  },
  {
    "version": "2.2.0",
    "releasedAt": "2026-09-02T19:19:11.164Z",
    "summary": "Risky Calls now fills Earnings from the same ticker, adds a Profit column (premium if every held lot is covered), and sizes Max loss to all shares sold covered."
  },
  {
    "version": "2.1.1",
    "releasedAt": "2026-09-02T19:06:17.009Z",
    "summary": "- History Deleted filter is now a Show chip, matching the other History filters"
  },
  {
    "version": "2.1.0",
    "releasedAt": "2026-09-02T18:47:40.508Z",
    "summary": "- Calls Risky mode now uses a two-handle min/max PoP slider instead of discrete 75–95% chips\n- Below-average call suggestions can be filtered to any PoP range; Max loss still shows when Risky is on"
  },
  {
    "version": "2.0.288",
    "releasedAt": "2026-09-02T18:16:42.030Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.287",
    "releasedAt": "2026-09-02T18:11:00.926Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.286",
    "releasedAt": "2026-09-02T17:42:50.666Z",
    "summary": "History(L) books only closed-month Robinhood margin interest; current and future months use the monthly forecast."
  },
  {
    "version": "2.0.285",
    "releasedAt": "2026-09-02T16:00:20.905Z",
    "summary": "Web ticker chips open the Stock Forge report; same-day option reopens import after BTC."
  },
  {
    "version": "2.0.284",
    "releasedAt": "2026-08-28T17:05:27.637Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.283",
    "releasedAt": "2026-08-28T16:47:50.240Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.282",
    "releasedAt": "2026-08-28T16:42:00.854Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.281",
    "releasedAt": "2026-08-28T16:18:54.063Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.280",
    "releasedAt": "2026-08-28T16:16:21.627Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.279",
    "releasedAt": "2026-08-28T16:13:19.719Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.278",
    "releasedAt": "2026-08-28T16:11:42.118Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.277",
    "releasedAt": "2026-08-27T18:59:48.041Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.276",
    "releasedAt": "2026-08-27T18:58:21.976Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.275",
    "releasedAt": "2026-08-27T18:58:04.468Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.274",
    "releasedAt": "2026-08-27T17:38:26.423Z",
    "summary": "Import history no longer goes blank when the updates file cannot be read\nAuto-import no longer re-opens shorts that are already on the ledger"
  },
  {
    "version": "2.0.273",
    "releasedAt": "2026-08-27T16:53:47.077Z",
    "summary": "Options rows come only from the own ledger; StockForge and Robinhood are quotes only"
  },
  {
    "version": "2.0.272",
    "releasedAt": "2026-08-27T15:59:02.823Z",
    "summary": "Options no longer flashes StockForge’s partial book before the own-ledger list loads"
  },
  {
    "version": "2.0.271",
    "releasedAt": "2026-08-26T21:25:07.797Z",
    "summary": "Options Open/Held ROC under 1% no longer displays 100× too high"
  },
  {
    "version": "2.0.270",
    "releasedAt": "2026-08-26T21:21:20.157Z",
    "summary": "Options Open ROC for calls now uses share avg cost, not cash strike collateral"
  },
  {
    "version": "2.0.269",
    "releasedAt": "2026-08-26T21:16:52.920Z",
    "summary": "Options Strike column uses the same white text for every strike"
  },
  {
    "version": "2.0.268",
    "releasedAt": "2026-08-26T21:05:42.344Z",
    "summary": "Options Open column now shows how many days the contract has been open"
  },
  {
    "version": "2.0.267",
    "releasedAt": "2026-08-26T20:49:04.824Z",
    "summary": "Wheel Lab scatter now zooms with the scroll wheel and pans with right-drag"
  },
  {
    "version": "2.0.266",
    "releasedAt": "2026-08-26T20:30:00.160Z",
    "summary": "Wheel Lab cost paths now read left to right; hover a close-dot to follow one name"
  },
  {
    "version": "2.0.265",
    "releasedAt": "2026-08-26T20:25:53.312Z",
    "summary": "Wheel Lab scatter zones are lighter and the stock dots are smaller"
  },
  {
    "version": "2.0.264",
    "releasedAt": "2026-08-26T20:20:57.970Z",
    "summary": "Wheel Lab scatter can show each put’s und. cost path, with a rebound card on extra assignments"
  },
  {
    "version": "2.0.263",
    "releasedAt": "2026-08-26T19:57:59.498Z",
    "summary": "Fix Wheel Lab crash on the income cards after the month-filter deploy"
  },
  {
    "version": "2.0.262",
    "releasedAt": "2026-08-26T19:56:54.470Z",
    "summary": "Wheel Lab adds Analytics-style month filters; still-assigned stays on the original assigned book when extra assigns grow"
  },
  {
    "version": "2.0.261",
    "releasedAt": "2026-08-26T17:25:36.161Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.260",
    "releasedAt": "2026-08-26T16:18:08.317Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.259",
    "releasedAt": "2026-08-26T15:07:30.123Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.258",
    "releasedAt": "2026-08-25T22:18:36.496Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.257",
    "releasedAt": "2026-08-25T22:11:47.476Z",
    "summary": "Manual broker/account can be removed and no longer reappears in Settings"
  },
  {
    "version": "2.0.256",
    "releasedAt": "2026-08-25T22:08:22.600Z",
    "summary": "Settings can add brokers again; Robinhood account names are imported from the snapshot"
  },
  {
    "version": "2.0.255",
    "releasedAt": "2026-08-25T22:00:50.947Z",
    "summary": "Settings can add, rename, and remove brokers and accounts; Robinhood import picks which ledger account new rows attach to"
  },
  {
    "version": "2.0.254",
    "releasedAt": "2026-08-23T01:10:41.963Z",
    "summary": "Wheel Lab modeled income now uses the same Analytics trading total as the slider baseline"
  },
  {
    "version": "2.0.253",
    "releasedAt": "2026-08-23T01:07:37.849Z",
    "summary": "Wheel Lab modeled income now uses all-contract premium as the baseline; the slider shows how that total would move"
  },
  {
    "version": "2.0.252",
    "releasedAt": "2026-08-23T01:04:37.825Z",
    "summary": "Wheel Lab: income card shows actual premium and slider delta; slider no longer blocks tab clicks"
  },
  {
    "version": "2.0.251",
    "releasedAt": "2026-08-23T00:59:29.879Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.250",
    "releasedAt": "2026-08-23T00:51:44.691Z",
    "summary": "Wheel Lab: missing historical POP is now assumed 70%"
  },
  {
    "version": "2.0.249",
    "releasedAt": "2026-08-23T00:50:58.396Z",
    "summary": "Wheel Lab: background refreshes no longer flash loading or steal slider focus"
  },
  {
    "version": "2.0.248",
    "releasedAt": "2026-08-23T00:47:43.294Z",
    "summary": "Wheel Lab: modeled premium card sits in the same row as avoided / still / extra assigned"
  },
  {
    "version": "2.0.247",
    "releasedAt": "2026-08-23T00:46:41.875Z",
    "summary": "Wheel Lab: compact Avoided / Still assigned / Extra assigned cards in one row beside the POP slider"
  },
  {
    "version": "2.0.246",
    "releasedAt": "2026-08-23T00:42:47.458Z",
    "summary": "Wheel Lab: fix scatter render crash (yMax is not defined) that left the tab stuck on loading"
  },
  {
    "version": "2.0.245",
    "releasedAt": "2026-08-23T00:42:10.595Z",
    "summary": "Wheel Lab: avoided / extra assigns are now a delta vs the actual book (0 avoided at or below 68%, 0 extra at or above 68%); loading no longer sticks if render fails"
  },
  {
    "version": "2.0.244",
    "releasedAt": "2026-08-23T00:37:45.944Z",
    "summary": "Wheel Lab: scatter zones and strike line now move with the POP slider; dots ring green or red for expire vs assign"
  },
  {
    "version": "2.0.243",
    "releasedAt": "2026-08-23T00:08:45.608Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.242",
    "releasedAt": "2026-08-23T00:04:38.616Z",
    "summary": "Wheel Lab: larger path chart; click a dot for contract details and the POP needed to avoid assignment"
  },
  {
    "version": "2.0.241",
    "releasedAt": "2026-08-23T00:02:20.743Z",
    "summary": "Wheel Lab: red extra-assign count on the Avoided assignment card when a lower POP would put more stock"
  },
  {
    "version": "2.0.240",
    "releasedAt": "2026-08-22T23:57:06.796Z",
    "summary": "Wheel Lab: Avoided assignment card under the POP slider"
  },
  {
    "version": "2.0.239",
    "releasedAt": "2026-08-22T23:56:00.583Z",
    "summary": "Wheel Lab: column (i) tooltips and labeled O / K / C path dots"
  },
  {
    "version": "2.0.238",
    "releasedAt": "2026-08-22T23:53:53.030Z",
    "summary": "Wheel Lab: clearer assignment chart — colored zones, plain-language labels, and a how-to-read"
  },
  {
    "version": "2.0.237",
    "releasedAt": "2026-08-22T23:51:35.706Z",
    "summary": "Wheel Lab: historical mix % above the POP-band and put-cycle tables"
  },
  {
    "version": "2.0.236",
    "releasedAt": "2026-08-22T23:49:00.690Z",
    "summary": "Wheel Lab: lower POP now increases modeled premium P/L (assignment mark is stock path, not booked profit)"
  },
  {
    "version": "2.0.235",
    "releasedAt": "2026-08-22T23:45:29.224Z",
    "summary": "Wheel Lab: large POP readout next to the what-if slider"
  },
  {
    "version": "2.0.234",
    "releasedAt": "2026-08-22T23:44:57.906Z",
    "summary": "Wheel Lab POP slider and what-if table now go down to 55%"
  },
  {
    "version": "2.0.233",
    "releasedAt": "2026-08-22T23:44:30.168Z",
    "summary": "Wheel Lab: Assigned / Expired / BTC use the same colored badges as Analytics"
  },
  {
    "version": "2.0.232",
    "releasedAt": "2026-08-22T23:42:37.833Z",
    "summary": "Wheel Lab slider: avoided/still-assigned percents plus a live modeled P/L (premium Δ and assignment mark)"
  },
  {
    "version": "2.0.231",
    "releasedAt": "2026-08-22T23:35:35.228Z",
    "summary": "Wheel Lab tab: assignment vs POP study on own-ledger short puts (missing historical POP treated as 68%)"
  },
  {
    "version": "2.0.230",
    "releasedAt": "2026-08-22T20:25:15.968Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.229",
    "releasedAt": "2026-08-22T20:16:35.942Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.228",
    "releasedAt": "2026-08-22T20:13:46.141Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.227",
    "releasedAt": "2026-08-22T19:45:39.414Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.226",
    "releasedAt": "2026-08-22T19:22:11.732Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.225",
    "releasedAt": "2026-08-22T19:15:27.985Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.224",
    "releasedAt": "2026-08-22T19:00:44.502Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.223",
    "releasedAt": "2026-08-22T18:58:28.767Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.222",
    "releasedAt": "2026-08-22T18:47:45.609Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.221",
    "releasedAt": "2026-08-22T18:28:44.499Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.220",
    "releasedAt": "2026-08-22T17:30:09.801Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.219",
    "releasedAt": "2026-08-22T17:23:35.190Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.218",
    "releasedAt": "2026-08-22T15:41:06.535Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.217",
    "releasedAt": "2026-08-21T16:23:15.039Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.216",
    "releasedAt": "2026-08-21T15:53:23.064Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.215",
    "releasedAt": "2026-08-21T15:38:25.122Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.214",
    "releasedAt": "2026-08-14T18:40:45.318Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.213",
    "releasedAt": "2026-08-14T18:34:08.870Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.212",
    "releasedAt": "2026-08-14T16:00:08.780Z",
    "summary": "Advisor no longer records open recommendations with $0 / no-quote premium (unmatched Cursor contracts such as a worthless WDC call)."
  },
  {
    "version": "2.0.211",
    "releasedAt": "2026-08-14T15:56:22.660Z",
    "summary": "Advisor rows on Calls/Puts use a blue background instead of a side stripe, and missing quote/fundamentals are filled from StockForge plus Market Data."
  },
  {
    "version": "2.0.210",
    "releasedAt": "2026-08-14T15:42:55.853Z",
    "summary": "Calls and Puts now insert advisor contracts that are missing from the screener as extra AI advice rows, with a badge and the blue advice dot."
  },
  {
    "version": "2.0.209",
    "releasedAt": "2026-08-14T15:39:27.723Z",
    "summary": "Calls and Puts now count advisor opens for that page even when the contract is filtered out of the current table, and keep those advised rows visible with the blue dot."
  },
  {
    "version": "2.0.208",
    "releasedAt": "2026-08-14T14:30:01.480Z",
    "summary": "Stop paper-agent runs from blocking advisor advice (and hanging Advising…); each agent now shows only its own running status."
  },
  {
    "version": "2.0.207",
    "releasedAt": "2026-08-14T02:26:56.380Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.206",
    "releasedAt": "2026-08-14T02:23:42.935Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.205",
    "releasedAt": "2026-08-14T02:21:50.673Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.204",
    "releasedAt": "2026-08-14T02:19:08.555Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.203",
    "releasedAt": "2026-08-14T02:12:08.928Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.202",
    "releasedAt": "2026-08-14T02:02:06.893Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.201",
    "releasedAt": "2026-08-14T01:21:00.644Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.200",
    "releasedAt": "2026-08-14T01:16:19.817Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.199",
    "releasedAt": "2026-08-14T01:11:18.741Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.198",
    "releasedAt": "2026-08-14T01:01:27.108Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.197",
    "releasedAt": "2026-08-14T00:53:32.009Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.196",
    "releasedAt": "2026-08-13T22:18:59.207Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.195",
    "releasedAt": "2026-08-13T22:16:12.792Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.194",
    "releasedAt": "2026-08-13T22:11:08.130Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.193",
    "releasedAt": "2026-08-13T22:10:01.390Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.192",
    "releasedAt": "2026-08-13T21:58:26.328Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.191",
    "releasedAt": "2026-08-13T21:45:58.676Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.190",
    "releasedAt": "2026-08-13T21:34:56.390Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.189",
    "releasedAt": "2026-08-13T21:00:55.356Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.188",
    "releasedAt": "2026-08-13T20:57:20.747Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.187",
    "releasedAt": "2026-08-13T19:19:20.772Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.186",
    "releasedAt": "2026-08-13T19:12:17.018Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.185",
    "releasedAt": "2026-08-13T19:11:01.831Z",
    "summary": "Keep the full advisor rationale in the advice modal (was capped at 280 characters)."
  },
  {
    "version": "2.0.184",
    "releasedAt": "2026-08-13T19:06:22.121Z",
    "summary": "Click the blue advice dot to open a full advice modal; move the dot to the bottom-right of the ticker cell so it no longer covers ITM/ATM."
  },
  {
    "version": "2.0.183",
    "releasedAt": "2026-08-13T19:02:48.476Z",
    "summary": "Show when advice was produced in the ticker-dot tooltip (today, 1.20 pm)."
  },
  {
    "version": "2.0.182",
    "releasedAt": "2026-08-13T19:01:39.439Z",
    "summary": "Paint the Agentic Add Advisor button in StockForge+ blue."
  },
  {
    "version": "2.0.181",
    "releasedAt": "2026-08-13T19:00:55.837Z",
    "summary": "Blue Run agent advice button with per-tab advice count and last-run time; bright blue ticker dots replace row highlights, with larger matching tooltips."
  },
  {
    "version": "2.0.180",
    "releasedAt": "2026-08-13T18:51:57.362Z",
    "summary": "Show bootstrap on advisor run-log rows, and keep Options/Agentic live while advice is running."
  },
  {
    "version": "2.0.179",
    "releasedAt": "2026-08-13T18:44:26.936Z",
    "summary": "Show advisor runs in progress on Agentic, and record hold recommendations when Cursor passes."
  },
  {
    "version": "2.0.178",
    "releasedAt": "2026-08-13T18:27:34.375Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.177",
    "releasedAt": "2026-08-13T18:25:18.692Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.176",
    "releasedAt": "2026-08-13T17:56:19.678Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.175",
    "releasedAt": "2026-08-13T17:21:42.418Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.174",
    "releasedAt": "2026-08-13T17:11:35.826Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.173",
    "releasedAt": "2026-08-13T17:07:47.309Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.173",
    "releasedAt": "2026-08-13T17:07:47.309Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.172",
    "releasedAt": "2026-08-13T16:54:05.800Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.171",
    "releasedAt": "2026-08-13T16:52:58.005Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.170",
    "releasedAt": "2026-08-13T16:51:43.475Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.169",
    "releasedAt": "2026-08-13T16:49:33.542Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.168",
    "releasedAt": "2026-08-13T16:49:22.366Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.167",
    "releasedAt": "2026-08-12T20:40:15.833Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.166",
    "releasedAt": "2026-08-12T14:46:59.532Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.165",
    "releasedAt": "2026-08-12T14:46:05.701Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.164",
    "releasedAt": "2026-08-12T14:43:12.050Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.163",
    "releasedAt": "2026-08-12T14:39:46.856Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.162",
    "releasedAt": "2026-08-12T14:37:50.821Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.161",
    "releasedAt": "2026-08-12T14:36:03.967Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.160",
    "releasedAt": "2026-08-11T02:15:41.255Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.159",
    "releasedAt": "2026-08-11T02:13:59.290Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.158",
    "releasedAt": "2026-08-10T23:47:08.551Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.157",
    "releasedAt": "2026-08-10T23:45:55.202Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.156",
    "releasedAt": "2026-08-10T23:35:13.525Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.155",
    "releasedAt": "2026-08-10T23:31:24.549Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.154",
    "releasedAt": "2026-08-10T23:29:40.688Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.152",
    "releasedAt": "2026-08-10T23:27:37.267Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.151",
    "releasedAt": "2026-08-10T23:25:22.909Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.150",
    "releasedAt": "2026-08-10T23:23:58.543Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.149",
    "releasedAt": "2026-08-10T23:23:24.514Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.148",
    "releasedAt": "2026-08-10T23:19:54.084Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.147",
    "releasedAt": "2026-08-10T23:19:14.162Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.146",
    "releasedAt": "2026-08-10T23:06:53.159Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.145",
    "releasedAt": "2026-08-10T23:05:56.381Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.144",
    "releasedAt": "2026-08-10T23:04:58.912Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.143",
    "releasedAt": "2026-08-10T23:00:01.392Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.142",
    "releasedAt": "2026-08-10T22:59:19.342Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.141",
    "releasedAt": "2026-08-10T22:58:31.675Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.140",
    "releasedAt": "2026-08-10T22:57:08.418Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.139",
    "releasedAt": "2026-08-10T22:56:15.953Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.138",
    "releasedAt": "2026-08-10T22:52:32.273Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.137",
    "releasedAt": "2026-08-10T22:20:32.925Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.136",
    "releasedAt": "2026-08-10T22:02:44.911Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.135",
    "releasedAt": "2026-08-10T21:22:51.831Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.134",
    "releasedAt": "2026-08-10T19:47:21.885Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.133",
    "releasedAt": "2026-08-10T19:24:32.603Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.132",
    "releasedAt": "2026-08-10T19:24:13.507Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.131",
    "releasedAt": "2026-08-10T15:23:16.214Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.130",
    "releasedAt": "2026-08-10T14:51:42.051Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.129",
    "releasedAt": "2026-08-10T15:05:00.000Z",
    "summary": "Calls Avg cost now uses the same own-ledger strike map as Stocks; peek cache no longer blocks avg refresh."
  },
  {
    "version": "2.0.128",
    "releasedAt": "2026-08-10T14:48:36.814Z",
    "summary": "Fix Calls tab crash (missing normalizeTicker import in profitability)."
  },
  {
    "version": "2.0.127",
    "releasedAt": "2026-08-10T14:47:08.992Z",
    "summary": "Calls screener Avg cost matches Stocks (own-ledger strike basis, not SF adj avg)."
  },
  {
    "version": "2.0.126",
    "releasedAt": "2026-08-10T14:42:16.814Z",
    "summary": "Options tab Avg cost uses strike-based share avg from own ledger (not premium-adjusted adj avg)."
  },
  {
    "version": "2.0.125",
    "releasedAt": "2026-08-10T00:52:04.053Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.124",
    "releasedAt": "2026-08-10T00:14:38.431Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.123",
    "releasedAt": "2026-08-09T23:24:53.054Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.122",
    "releasedAt": "2026-08-09T23:06:50.814Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.121",
    "releasedAt": "2026-08-09T22:29:28.745Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.120",
    "releasedAt": "2026-08-09T22:18:08.488Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.119",
    "releasedAt": "2026-08-09T21:57:06.640Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.118",
    "releasedAt": "2026-08-09T21:50:37.066Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.117",
    "releasedAt": "2026-08-09T21:42:56.176Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.116",
    "releasedAt": "2026-08-09T21:36:25.661Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.115",
    "releasedAt": "2026-08-09T21:23:29.231Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.114",
    "releasedAt": "2026-08-09T21:15:03.881Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.113",
    "releasedAt": "2026-08-09T21:02:42.841Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.112",
    "releasedAt": "2026-08-09T00:52:59.580Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.111",
    "releasedAt": "2026-08-09T00:48:57.687Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.110",
    "releasedAt": "2026-08-09T00:35:47.875Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.109",
    "releasedAt": "2026-08-09T00:21:01.834Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.108",
    "releasedAt": "2026-08-09T00:12:57.854Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.107",
    "releasedAt": "2026-08-08T22:36:39.199Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.106",
    "releasedAt": "2026-08-08T22:06:24.298Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.105",
    "releasedAt": "2026-08-08T21:44:59.396Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.104",
    "releasedAt": "2026-08-08T21:30:38.397Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.103",
    "releasedAt": "2026-08-08T21:18:38.721Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.102",
    "releasedAt": "2026-08-08T21:16:09.036Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.101",
    "releasedAt": "2026-08-08T21:14:32.230Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.100",
    "releasedAt": "2026-08-08T21:11:58.387Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.99",
    "releasedAt": "2026-08-08T21:08:08.725Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.98",
    "releasedAt": "2026-08-08T21:05:40.795Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.97",
    "releasedAt": "2026-08-08T21:03:04.290Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.96",
    "releasedAt": "2026-08-08T20:57:53.115Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.95",
    "releasedAt": "2026-08-08T20:51:50.823Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.94",
    "releasedAt": "2026-08-08T20:42:15.495Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.93",
    "releasedAt": "2026-08-08T20:41:35.533Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.92",
    "releasedAt": "2026-08-08T20:39:26.579Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.91",
    "releasedAt": "2026-08-08T20:36:42.956Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.90",
    "releasedAt": "2026-08-08T20:36:25.870Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.89",
    "releasedAt": "2026-08-08T20:26:45.629Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.88",
    "releasedAt": "2026-08-08T20:26:24.327Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.87",
    "releasedAt": "2026-08-08T20:14:38.500Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.86",
    "releasedAt": "2026-08-08T20:09:19.990Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.85",
    "releasedAt": "2026-08-08T20:06:52.295Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.84",
    "releasedAt": "2026-08-08T20:04:11.400Z",
    "summary": "- Forecast 2027+: project tax from trading as Cash Ops withdrawals (payment-log dates; default Mar 30).\n- Tax Q1 forecast assumption date Apr 10 → Mar 30."
  },
  {
    "version": "2.0.83",
    "releasedAt": "2026-08-08T19:58:40.770Z",
    "summary": "- Own Capital only deducts tax paid from the trading account (default on for TY2026+; off for earlier / W-2).\n- Tax payments modal: “Paid from trading account” checkbox + Source column."
  },
  {
    "version": "2.0.82",
    "releasedAt": "2026-08-08T19:55:03.716Z",
    "summary": "- Analytics(L): show IRS tax cash (balance-due/extension) on Own Capital when it reduces EOM.\n- Analytics(L): stop inventing SF $0.06/trade fees in Cost/Plan (fees already in trade income)."
  },
  {
    "version": "2.0.81",
    "releasedAt": "2026-08-08T19:48:07.525Z",
    "summary": "- Stop assign-linking stock sells to option shorts that were already BTC/EXP closed.\n- Show call-assignment ASG rows when RH stock sale price is near strike."
  },
  {
    "version": "2.0.80",
    "releasedAt": "2026-08-08T19:26:14.417Z",
    "summary": "- Fix Analytics(L) losing Tastytrade rows when Analytics+ refreshes the shared panel.\n- Classify option income chronologically and per broker account so TT/RH contracts do not collide."
  },
  {
    "version": "2.0.79",
    "releasedAt": "2026-08-08T19:04:49.551Z",
    "summary": "- Remove Own Capital month-end correction from Analytics+ (cash ops only)."
  },
  {
    "version": "2.0.78",
    "releasedAt": "2026-08-08T19:03:19.888Z",
    "summary": "- Show Own Capital month-end Correction on Analytics+; clear Nov 2025 plug that offset cash added."
  },
  {
    "version": "2.0.77",
    "releasedAt": "2026-08-08T18:59:21.910Z",
    "summary": "- Add System and Account columns to History(L) and Analytics(L) income tables."
  },
  {
    "version": "2.0.76",
    "releasedAt": "2026-08-08T18:56:50.894Z",
    "summary": "- Fix own-ledger Tastytrade missing expiration/assignment closes (Receive Deliver import + backfill)."
  },
  {
    "version": "2.0.75",
    "releasedAt": "2026-08-08T18:48:33.442Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.74",
    "releasedAt": "2026-08-08T18:46:28.738Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.73",
    "releasedAt": "2026-08-08T18:41:19.270Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.72",
    "releasedAt": "2026-08-08T18:26:06.075Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.71",
    "releasedAt": "2026-08-08T18:20:52.048Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.70",
    "releasedAt": "2026-08-08T18:03:14.568Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.69",
    "releasedAt": "2026-08-07T23:11:52.801Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.68",
    "releasedAt": "2026-08-07T23:06:07.133Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.67",
    "releasedAt": "2026-08-07T23:02:59.663Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.66",
    "releasedAt": "2026-08-07T22:45:50.859Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.65",
    "releasedAt": "2026-08-07T22:40:58.231Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.64",
    "releasedAt": "2026-08-07T22:37:18.560Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.63",
    "releasedAt": "2026-08-07T22:34:11.562Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.62",
    "releasedAt": "2026-08-07T22:28:13.935Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.61",
    "releasedAt": "2026-08-07T22:22:36.109Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.60",
    "releasedAt": "2026-08-07T22:17:08.852Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.59",
    "releasedAt": "2026-08-07T22:13:16.323Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.58",
    "releasedAt": "2026-08-07T22:04:56.855Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.57",
    "releasedAt": "2026-08-07T21:59:10.211Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.56",
    "releasedAt": "2026-08-07T21:56:34.873Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.55",
    "releasedAt": "2026-08-07T20:47:46.164Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.54",
    "releasedAt": "2026-08-07T20:27:05.498Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.53",
    "releasedAt": "2026-08-07T20:23:44.564Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.52",
    "releasedAt": "2026-08-07T20:21:28.805Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.51",
    "releasedAt": "2026-08-07T20:14:30.348Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.50",
    "releasedAt": "2026-08-07T20:08:24.056Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.49",
    "releasedAt": "2026-08-07T20:04:04.071Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.48",
    "releasedAt": "2026-08-07T19:59:23.589Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.47",
    "releasedAt": "2026-08-07T19:58:19.901Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.46",
    "releasedAt": "2026-08-07T19:50:46.317Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.45",
    "releasedAt": "2026-08-07T19:37:06.377Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.44",
    "releasedAt": "2026-08-07T18:56:15.941Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.43",
    "releasedAt": "2026-08-07T18:49:58.653Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.42",
    "releasedAt": "2026-08-07T18:46:50.012Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.41",
    "releasedAt": "2026-08-07T18:42:39.167Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.40",
    "releasedAt": "2026-08-07T17:35:28.950Z",
    "summary": "History month chips show newest-first (Dec → Jan), matching Analytics+."
  },
  {
    "version": "2.0.39",
    "releasedAt": "2026-08-07T17:32:33.582Z",
    "summary": "History and History (SF+ ledger): year + month chip filters like Analytics+."
  },
  {
    "version": "2.0.38",
    "releasedAt": "2026-08-07T17:28:18.153Z",
    "summary": "History and History (SF+ ledger): Ticker column is no longer locked in the column picker."
  },
  {
    "version": "2.0.37",
    "releasedAt": "2026-08-07T17:26:14.642Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.36",
    "releasedAt": "2026-08-07T17:25:38.739Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.35",
    "releasedAt": "2026-08-07T17:23:27.637Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.34",
    "releasedAt": "2026-08-07T17:22:43.090Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.33",
    "releasedAt": "2026-08-07T16:30:49.414Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.32",
    "releasedAt": "2026-08-07T16:25:54.291Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.31",
    "releasedAt": "2026-08-07T16:19:30.317Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.30",
    "releasedAt": "2026-08-07T16:06:03.438Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.29",
    "releasedAt": "2026-08-07T15:58:09.693Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.28",
    "releasedAt": "2026-08-07T13:30:27.983Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.27",
    "releasedAt": "2026-08-06T20:44:59.089Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.26",
    "releasedAt": "2026-08-06T20:33:24.102Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.25",
    "releasedAt": "2026-08-06T20:31:14.299Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.24",
    "releasedAt": "2026-08-06T20:27:55.311Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.23",
    "releasedAt": "2026-08-06T20:16:13.839Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.22",
    "releasedAt": "2026-08-06T20:15:15.973Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.21",
    "releasedAt": "2026-08-06T20:14:10.587Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.20",
    "releasedAt": "2026-08-06T20:09:53.200Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.19",
    "releasedAt": "2026-08-06T20:05:53.230Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.18",
    "releasedAt": "2026-08-06T19:28:36.593Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.17",
    "releasedAt": "2026-08-06T19:20:26.336Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.16",
    "releasedAt": "2026-08-06T19:19:50.760Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.15",
    "releasedAt": "2026-08-06T19:17:27.977Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.14",
    "releasedAt": "2026-08-06T19:13:02.264Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.13",
    "releasedAt": "2026-08-06T18:19:19.049Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.12",
    "releasedAt": "2026-08-06T18:18:45.584Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.11",
    "releasedAt": "2026-08-06T18:09:33.360Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.10",
    "releasedAt": "2026-08-06T18:08:19.117Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.9",
    "releasedAt": "2026-08-06T16:38:35.063Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.8",
    "releasedAt": "2026-08-06T16:28:13.504Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.7",
    "releasedAt": "2026-08-06T15:34:26.117Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.6",
    "releasedAt": "2026-08-06T15:02:59.397Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.5",
    "releasedAt": "2026-08-06T14:23:07.725Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.4",
    "releasedAt": "2026-08-06T14:21:09.565Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.3",
    "releasedAt": "2026-08-06T14:16:11.432Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.2",
    "releasedAt": "2026-08-06T00:44:19.138Z",
    "summary": "Maintenance release."
  },
  {
    "version": "2.0.1",
    "releasedAt": "2026-08-05T23:43:50.045Z",
    "summary": "Major v2: own ledger foundation (SQLite on proxy, /own-ledger APIs, History(L) and Analytics(L) on web).\nTastytrade CSV and Robinhood import endpoints with TT→RH parallel timeline (Oct 2025–Dec 16 2025)."
  },
  {
    "version": "1.7.46",
    "releasedAt": "2026-08-05T22:45:05.082Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.45",
    "releasedAt": "2026-08-05T22:41:44.959Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.44",
    "releasedAt": "2026-08-05T22:39:40.027Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.43",
    "releasedAt": "2026-08-05T22:36:53.016Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.42",
    "releasedAt": "2026-08-05T22:27:21.491Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.41",
    "releasedAt": "2026-08-05T22:24:46.832Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.40",
    "releasedAt": "2026-08-05T22:19:25.002Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.39",
    "releasedAt": "2026-08-05T22:14:38.151Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.38",
    "releasedAt": "2026-08-05T22:12:53.213Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.37",
    "releasedAt": "2026-08-05T22:07:52.143Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.36",
    "releasedAt": "2026-08-05T22:05:16.918Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.35",
    "releasedAt": "2026-08-05T21:47:57.900Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.34",
    "releasedAt": "2026-08-05T21:37:14.855Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.33",
    "releasedAt": "2026-08-05T21:21:44.658Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.32",
    "releasedAt": "2026-08-05T21:21:12.733Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.31",
    "releasedAt": "2026-08-05T21:03:12.777Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.30",
    "releasedAt": "2026-08-05T21:01:59.093Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.29",
    "releasedAt": "2026-08-05T20:57:44.496Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.28",
    "releasedAt": "2026-08-05T20:54:25.266Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.27",
    "releasedAt": "2026-08-05T20:39:31.058Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.26",
    "releasedAt": "2026-08-05T20:38:15.439Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.25",
    "releasedAt": "2026-08-05T20:37:33.605Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.24",
    "releasedAt": "2026-08-05T20:11:30.686Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.23",
    "releasedAt": "2026-08-05T20:06:21.573Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.22",
    "releasedAt": "2026-08-05T19:07:35.986Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.21",
    "releasedAt": "2026-08-04T22:18:05.287Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.20",
    "releasedAt": "2026-08-04T22:16:58.389Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.19",
    "releasedAt": "2026-08-04T22:12:06.468Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.18",
    "releasedAt": "2026-08-04T22:07:01.056Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.17",
    "releasedAt": "2026-08-04T22:01:55.776Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.16",
    "releasedAt": "2026-08-04T21:40:39.077Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.15",
    "releasedAt": "2026-08-04T21:23:18.168Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.14",
    "releasedAt": "2026-08-04T21:21:48.053Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.13",
    "releasedAt": "2026-08-04T21:16:38.625Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.12",
    "releasedAt": "2026-08-04T21:12:10.818Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.11",
    "releasedAt": "2026-08-04T21:07:57.132Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.10",
    "releasedAt": "2026-08-04T21:06:01.311Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.9",
    "releasedAt": "2026-08-04T21:02:20.935Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.8",
    "releasedAt": "2026-08-04T20:57:11.051Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.7",
    "releasedAt": "2026-08-04T20:56:51.611Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.6",
    "releasedAt": "2026-08-04T20:52:38.612Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.5",
    "releasedAt": "2026-08-04T20:50:30.570Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.4",
    "releasedAt": "2026-08-04T20:47:23.283Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.3",
    "releasedAt": "2026-08-04T20:36:43.031Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.2",
    "releasedAt": "2026-08-04T20:27:53.234Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.1",
    "releasedAt": "2026-08-04T20:19:42.078Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.7.0",
    "releasedAt": "2026-08-04T20:13:31.548Z",
    "summary": "Agent paper tables: separate options/transaction ticker filters with per-row Filter menus.\nMove why/info onto ticker chips; pin ticker column and polish premium/action styling."
  },
  {
    "version": "1.6.97",
    "releasedAt": "2026-08-04T20:06:39.338Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.96",
    "releasedAt": "2026-08-04T20:00:47.596Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.95",
    "releasedAt": "2026-08-04T19:58:46.731Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.94",
    "releasedAt": "2026-08-04T19:55:58.212Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.93",
    "releasedAt": "2026-08-04T19:48:07.961Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.92",
    "releasedAt": "2026-08-04T19:45:22.280Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.91",
    "releasedAt": "2026-08-04T19:44:56.239Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.90",
    "releasedAt": "2026-08-04T19:42:25.200Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.89",
    "releasedAt": "2026-08-04T19:41:04.001Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.88",
    "releasedAt": "2026-08-04T19:38:30.725Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.87",
    "releasedAt": "2026-08-04T19:37:43.888Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.86",
    "releasedAt": "2026-08-04T19:37:13.359Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.85",
    "releasedAt": "2026-08-04T19:36:29.618Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.84",
    "releasedAt": "2026-08-04T19:35:27.913Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.83",
    "releasedAt": "2026-08-04T19:30:48.155Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.82",
    "releasedAt": "2026-08-04T19:27:06.981Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.81",
    "releasedAt": "2026-08-04T19:22:14.661Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.80",
    "releasedAt": "2026-08-04T19:19:09.814Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.79",
    "releasedAt": "2026-08-04T19:15:52.968Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.78",
    "releasedAt": "2026-08-04T19:12:45.991Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.77",
    "releasedAt": "2026-08-04T18:53:17.244Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.76",
    "releasedAt": "2026-08-04T18:49:27.275Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.75",
    "releasedAt": "2026-08-04T18:46:13.677Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.74",
    "releasedAt": "2026-08-04T18:41:58.947Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.73",
    "releasedAt": "2026-08-04T18:36:56.760Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.72",
    "releasedAt": "2026-08-04T18:34:44.071Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.71",
    "releasedAt": "2026-08-04T18:30:49.771Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.70",
    "releasedAt": "2026-08-04T18:26:31.523Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.69",
    "releasedAt": "2026-08-04T18:24:04.248Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.68",
    "releasedAt": "2026-08-04T18:17:40.031Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.67",
    "releasedAt": "2026-08-04T18:14:32.809Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.66",
    "releasedAt": "2026-08-04T18:12:44.569Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.65",
    "releasedAt": "2026-08-04T18:09:33.570Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.64",
    "releasedAt": "2026-08-04T18:05:43.106Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.63",
    "releasedAt": "2026-08-04T18:02:52.432Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.62",
    "releasedAt": "2026-08-04T18:00:43.855Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.61",
    "releasedAt": "2026-08-04T18:00:12.272Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.60",
    "releasedAt": "2026-08-04T17:57:41.298Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.59",
    "releasedAt": "2026-08-04T17:56:33.993Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.58",
    "releasedAt": "2026-08-04T17:55:47.238Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.57",
    "releasedAt": "2026-08-04T17:51:09.095Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.56",
    "releasedAt": "2026-08-04T17:48:06.749Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.55",
    "releasedAt": "2026-08-04T17:43:53.194Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.54",
    "releasedAt": "2026-08-04T17:43:37.655Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.53",
    "releasedAt": "2026-08-04T17:40:43.876Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.52",
    "releasedAt": "2026-08-04T17:38:05.692Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.51",
    "releasedAt": "2026-08-04T17:35:49.582Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.50",
    "releasedAt": "2026-08-04T17:30:01.713Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.49",
    "releasedAt": "2026-08-04T17:23:21.242Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.48",
    "releasedAt": "2026-08-04T17:23:07.118Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.47",
    "releasedAt": "2026-08-04T17:19:17.368Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.46",
    "releasedAt": "2026-08-04T17:12:40.905Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.45",
    "releasedAt": "2026-08-04T17:10:48.618Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.44",
    "releasedAt": "2026-08-04T17:08:55.444Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.43",
    "releasedAt": "2026-08-04T17:06:42.971Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.42",
    "releasedAt": "2026-08-04T17:04:28.139Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.41",
    "releasedAt": "2026-08-04T17:02:38.871Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.40",
    "releasedAt": "2026-08-04T16:59:38.277Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.39",
    "releasedAt": "2026-08-04T16:56:01.698Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.38",
    "releasedAt": "2026-08-04T16:53:26.574Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.37",
    "releasedAt": "2026-08-04T16:51:56.381Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.36",
    "releasedAt": "2026-08-04T16:49:50.586Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.35",
    "releasedAt": "2026-08-04T16:48:30.449Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.34",
    "releasedAt": "2026-08-04T16:42:21.414Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.33",
    "releasedAt": "2026-08-04T16:41:31.932Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.32",
    "releasedAt": "2026-08-04T16:39:07.920Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.31",
    "releasedAt": "2026-08-04T16:37:16.199Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.30",
    "releasedAt": "2026-08-04T16:09:26.685Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.29",
    "releasedAt": "2026-08-04T16:05:35.574Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.28",
    "releasedAt": "2026-08-04T16:04:45.892Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.27",
    "releasedAt": "2026-08-04T15:49:35.871Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.26",
    "releasedAt": "2026-08-04T15:30:19.951Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.25",
    "releasedAt": "2026-08-04T15:10:02.761Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.24",
    "releasedAt": "2026-08-04T14:57:44.812Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.23",
    "releasedAt": "2026-08-04T14:48:09.963Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.22",
    "releasedAt": "2026-08-04T14:07:35.125Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.21",
    "releasedAt": "2026-08-03T21:52:01.320Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.20",
    "releasedAt": "2026-08-03T21:45:11.686Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.19",
    "releasedAt": "2026-08-03T21:43:34.206Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.18",
    "releasedAt": "2026-08-03T21:41:43.693Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.17",
    "releasedAt": "2026-08-03T21:40:46.107Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.16",
    "releasedAt": "2026-08-03T21:34:39.343Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.15",
    "releasedAt": "2026-08-03T21:21:59.007Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.14",
    "releasedAt": "2026-08-03T21:17:09.510Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.13",
    "releasedAt": "2026-08-03T21:12:59.666Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.12",
    "releasedAt": "2026-08-03T21:08:59.667Z",
    "summary": "Import row expand shows linked ledger transaction (lookup when IDs missing)."
  },
  {
    "version": "1.6.11",
    "releasedAt": "2026-08-03T21:06:02.650Z",
    "summary": "Import controls row: compact sync interval input and vertical center alignment."
  },
  {
    "version": "1.6.10",
    "releasedAt": "2026-08-03T21:04:12.294Z",
    "summary": "Auto import help text moved to label tooltip."
  },
  {
    "version": "1.6.9",
    "releasedAt": "2026-08-03T21:03:03.784Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.6.8",
    "releasedAt": "2026-08-03T21:02:49.876Z",
    "summary": "Import header shows sync status; drop Last import from status line."
  },
  {
    "version": "1.6.7",
    "releasedAt": "2026-08-03T21:01:46.289Z",
    "summary": "Fix missing Sync Now button in Import controls."
  },
  {
    "version": "1.6.6",
    "releasedAt": "2026-08-03T21:00:01.011Z",
    "summary": "Import controls: Sync Now button next to sync settings (renamed from Refresh snapshot)."
  },
  {
    "version": "1.6.5",
    "releasedAt": "2026-08-03T20:57:07.805Z",
    "summary": "Import settings labels stay on one line."
  },
  {
    "version": "1.6.4",
    "releasedAt": "2026-08-03T20:54:54.938Z",
    "summary": "Remove underline from Import section header."
  },
  {
    "version": "1.6.3",
    "releasedAt": "2026-08-03T20:54:29.822Z",
    "summary": "Import settings: Enable Sync left, Sync every center, Auto import transactions right."
  },
  {
    "version": "1.6.2",
    "releasedAt": "2026-08-03T20:47:37.277Z",
    "summary": "Import tab groups Robinhood changes into daily collapsible sections like Analytics."
  },
  {
    "version": "1.6.1",
    "releasedAt": "2026-08-03T20:38:44.285Z",
    "summary": "Deploy now increments patch version (1.6.x) instead of minor (1.x.0)."
  },
  {
    "version": "1.6.0",
    "releasedAt": "2026-08-03T20:38:05.129Z",
    "summary": "Maintenance release."
  },
  {
    "version": "1.5.0",
    "releasedAt": "2026-08-03T20:37:54.983Z",
    "summary": "Fix ticker filter fields being autofilled with login email (Chrome autofill guard)."
  },
  {
    "version": "1.4.0",
    "releasedAt": "2026-08-03T20:34:03.184Z",
    "summary": "Why modal: structured Selection / Cursor / Unsuitable sections; no more truncation on Ann. ROC or dates."
  },
  {
    "version": "1.3.0",
    "releasedAt": "2026-08-03T20:32:38.363Z",
    "summary": "Rename Broker tab to Import; internal tab id is now import (was agentic) to avoid confusion with the Agentic tab.\nTab preferences migrate automatically from the old agentic id."
  },
  {
    "version": "1.2.0",
    "releasedAt": "2026-08-03T20:25:47.252Z",
    "summary": "Release notes modal lists previous versions with a link to each release's notes."
  },
  {
    "version": "1.1.0",
    "releasedAt": "2026-08-03T20:24:57.128Z",
    "summary": "Settings show app version and release date on web and mobile.\nRelease notes link opens a modal with summaries for each version.\nDeploy auto-increments the minor version (1.x.0)."
  },
  {
    "version": "1.0.0",
    "releasedAt": "2026-08-03T20:30:00.000Z",
    "summary": "Web and mobile-only release after removing the Chrome extension.\nBroker auto-import with scheduled Robinhood pulls and ledger dedup.\nAgentic Why icon + modal on transaction log and open positions.\nImport section UI polish, options table header alignment fixes."
  }
];

export function formatReleaseDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso.slice(0, 10);
  }
}
